import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/prism_admin/endpoints'
import moment from 'moment'
import Vue from 'vue'
import axios from 'axios';
import { strictValidString } from '../../../../../utils/common';

export const actions = { 
    [Const.RUN_SUBSCRIPTION_LIST]({ commit, state, getters, dispatch }, data) {
        const apiUrl = Enpoints.BASE_URL + Enpoints.EP_GET_SUBSCRIPTION_LIST;
        const headers = { 'Authorization': 'Bearer ' + getters.GET_TOKEN };
      
        return axios.post(apiUrl, data, { headers })
          .then((response) => {
            const responseData = response.data;
            if ('info' in responseData && responseData.info === 'OK') {
              commit(Const.SET_SUBSCRIPTION_LIST, { payload: responseData.data });
            }
          })
          .catch((error) => {
            _handleErrorResponse(error, commit);
            Vue.notify({
              group: 'foo',
              text: strictValidString(error.msg) ? error.msg : 'something went wrong!',
              type: 'error'
            });
          });
    },
    [Const.RUN_SUBSCRIPTION_DETAIL]({ commit, state, getters, dispatch }, data) {
        const apiUrl = Enpoints.BASE_URL + Enpoints.EP_GET_SUBSCRIPTION_DETAIL;
        const headers = { 'Authorization': 'Bearer ' + getters.GET_TOKEN };
      
        return axios.post(apiUrl, data, { headers })
          .then((response) => {
            const responseData = response.data;
            if ('info' in responseData && responseData.info === 'OK') {
              commit(Const.SET_SUBSCRIPTION_DETAIL, { payload: responseData.data[0] });
            }
          })
          .catch((error) => {
            _handleErrorResponse(error, commit);
            Vue.notify({
              group: 'foo',
              text: strictValidString(error.msg) ? error.msg : 'something went wrong!',
              type: 'error'
            });
          });
    }, 
    [Const.RUN_KYC_UPLOAD_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_KYC_UPLOAD_DOCUMENT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    parameter.$refs.doc.value = ''
                    parameter.reset()
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }

                    }

                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    }, 
    [Const.RUN_KYC_USER_LISTING]({ commit, state, getters, dispatch }, data) {
        try {
            let user_types = '';
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout

            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_KYC_USER_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            commit(Const.SET_KYC_USER_LISTING, data.data)
                            if(inputJson.download != undefined && inputJson.download == true){
                               parameter.ksCsvExport(data.data.records) 
                               parameter.download = false
                            }
                        } else {
                            commit(Const.SET_KYC_USER_LISTING, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_USER_OTP_CHECK]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_OTP_CHECK, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                           parameter.csvExport(data.data, 'user_sheet.csv')
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },


    [Const.RUN_CREATE_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            parameter.pageLoader1 = true
            delete inputJson.rout

            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                           parameter.close()
                           parameter.$notify({
                            group: 'foo',
                            text: 'Ticket created successfully',
                            type: 'success'
                        });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_SPLITTER_UPLOAD]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true

            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SPLITTER_TOOL_UPLOAD, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        console.log(data)
                        if (data.info == 'OK') {
                            parameter.$router.push({ path: '/spltter-tool' })
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_CVL_DATA_API]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CVL_DATA_API, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'push data successfully',
                                type: 'success'
                            });
                        } else {
                           
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_USER_PAN_ATTEMPT_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_USER_PAN_ATTEMPT_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_USER_PAN_ATTEMPT_LIST, data.data)
                        } else {
                            commit(Const.SET_USER_PAN_ATTEMPT_LIST, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_UPDATE_USER_PAN_ATTEMPTS]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPDATE_USER_PAN_ATTEMPTS, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing()
                            parameter.infoModule = {}
                            parameter.$notify({
                                group: 'foo',
                                text: 'attempt assigned successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DETAIL_USER_PAN_ATTEMPTS]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DETAIL_USER_PAN_ATTEMPTS, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.detailInfoModule = data.data
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_DOWNLOAD_PAYMENT_SHEET]({commit, state,getters,dispatch}, data){ 
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter          
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DOWNLOAD_PAYMENT_SHEET, inputJson ,{'Authorization': 'Bearer ' + getters.GET_TOKEN})
            .map(response => response.data)
            .subscribe(data => 
            {   
                parameter.pageLoader1 = false
                if ('info' in data){
                    if (data.info === 'OK') {
                        if(data.data.UPI && data.data.UPI.length > 0){
                            let upiArray = [] ;
                            for(let i=0 ; i<=data.data.UPI.length-1 ; i++){
                                let upiJson = {
                                    'client code' : data.data.UPI[i].client_code,
                                    'Amount' :  data.data.UPI[i].collect_trans_amount,
                                    'DateTime' : data.data.UPI[i].finalDate.toString(),
                                    'Status' : data.data.UPI[i].final_status
                                }
                                upiArray.push(upiJson)
                                if(i==data.data.UPI.length-1){
                                    data.data.upiArray =  upiArray
                                    parameter.csvExport(data.data.upiArray, 'upi_payment_sheet.csv')
                                }
                            }
                        }
                        if(data.data.VIRTUAL && data.data.VIRTUAL.length > 0){
                            let virtualArray = [] ;
                            for(let i=0 ; i<=data.data.VIRTUAL.length-1 ; i++){
                                let virtualJson = {
                                    'client code' : data.data.VIRTUAL[i].client_code,
                                    'Amount' :  data.data.VIRTUAL[i].amount,
                                    'DateTime' : data.data.VIRTUAL[i].creditDateTime.toString(),
                                    'Status' : data.data.VIRTUAL[i].reason
                                }
                                virtualArray.push(virtualJson)
                                if(i==data.data.VIRTUAL.length-1){
                                    data.data.virtualArray =  virtualArray
                                    parameter.csvExport(data.data.virtualArray, 'virtual_payment_sheet.csv')
                                }
                            }
                        }
                    }
                    else{
                        parameter.flashError(data.msg, {timeout: msz_display_time})
                    }
                }
            },
            e => {  _handleErrorResponse(e, commit) }) 
        }catch(ex){ _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_USER_XML_DOWNLOAD]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_XML_DOWNLOAD, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.xml_download_btn = data.data.xml_download_btn_flag
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_BACKSTAGE_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_BACKSTAGE_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if ('info' in data) {
                        parameter.$parent.pageLoader = false
                        if (data.info == 'OK') {
                            parameter.viewTicket(inputJson.ticket_id)
                            parameter.backStageReason = ''
                            parameter.backstageTicketFlag = false
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },


    [Const.RUN_REMOVE_USER_FROM_HOLD_STAGE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.pageLoader1 = true
            // alert(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_REFERRED_LIST)
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_REMOVE_USER_FROM_HOLD_STAGE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing("1",'','verify_sign')
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_DOWNLOAD_EXCEL_SHEET_USER_DETAIL]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            //parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DOWNLOAD_EXCEL_SHEET_USER_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    //parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            let step_information_list = {
                                
                                '-2' : 'Personal Information Done',
                                '-1' : 'Address Information Done',
                                '0'  : 'Bank Account Information Done',
                                '1'  : 'Other Information Done',
                                '1.5': 'Nominee',
                                '2'  : 'Demat/Exsisting Account Information Done',
                                '3'  : 'Trading Segment Information Done',
                                '4'  : 'Upload Documents Done',
                                '5'  : 'IPV Done',
                                '6'  : 'ready for verification',
                                '7'  : 'Esign Pending',
                                '8'  : 'Esign Done',
                                '9'  : 'Exchange Punch Pending',
                                '10' : 'registeration complete'
                            };
                            for(let i=0 ; i<=data.data.records.length-1 ; i++){
                                data.data.records[i].FROM_KRA =  (data.data.records[i].FROM_KRA != undefined && data.data.records[i].FROM_KRA != null) ? (parseInt(data.data.records[i].FROM_KRA) == 1) ? 'kra' : 'Non-kra' : '-'
                                data.data.records[i].step = step_information_list[(data.data.records[i].step).toString()]
                                data.data.records[i].source_data = data.data.records[i].source_data
                                data.data.records[i]['publisher_id'] = data.data.records[i].source_data.publisher_id
                                data.data.records[i]['adv_id'] = data.data.records[i].source_data.adv_id
                                data.data.records[i]['transaction_id'] = data.data.records[i].source_data.transaction_id
                                delete data.data.records[i].source_data
                                data.data.records[i].created =  moment(data.data.records[i].created).format('DD-MM-YYYY hh:mm:ss')
                                if(i == data.data.records.length-1){
                                    parameter.csvExport(data.data.records, 'user-data.csv')
                                }
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    
    [Const.RUN_USER_LIST_FOR_SQUADIQ]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.pageLoader1 = true
            // alert(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_REFERRED_LIST)
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_LIST_FOR_SQUADIQ, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_USER_LIST_FOR_SQUADIQ, data.data)
                        } else {
                            commit(Const.SET_USER_LIST_FOR_SQUADIQ, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CREATE_USER_SQUADIQ]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_USER_SQUADIQ, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') { 
                            if(data.data.length > 0){
                                let arrayData = []
                                for(let i= 0 ; i<=data.data[0].length-1 ; i++){
                                    arrayData.push(data.data[0][i].lead_id)

                                    if(i==data.data[0].length-1){
                                        dispatch(Const.RUN_TRANSFER_DATA_TO_SQUADIQ, { "idArray": arrayData, "rout": rout, "parameter": parameter });
                                    }
                                }
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_USER_UPDATE_FOR_SQUADIQ]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.pageLoaderPopup = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_UPDATE_FOR_SQUADIQ, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoaderPopup = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.reset()
                            parameter.$notify({
                                group: 'foo',
                                text: 'lead update successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                e => {
                     _handleErrorResponse(e, commit)
                })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_TRANSFER_DATA_TO_SQUADIQ]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
           
            const rout = inputJson.rout
            delete inputJson.rout
            parameter.pageLoader1 = true
            // alert(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_REFERRED_LIST)
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_TRANSFER_DATA_TO_SQUADIQ, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing("1",'')
                            parameter.array_verify_sign = []
                            parameter.arrayData = {}
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        } else {
                            parameter.listing("1",'')
                            parameter.array_verify_sign = []
                            parameter.arrayData = {}
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        alert('1234'); console.log(e); _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_SQUAD_DATA_DOWNLOAD]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_LIST_FOR_SQUADIQ, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let step_information_list = {
                                '-2' : 'Personal information page',
                                '-1' : 'Address Information',
                                '0'  : 'Bank information',
                                '1'  : 'Other information',
                                '1.5': 'Nominee',
                                '2'  : 'Demat/Exsisting Account Information',
                                '3'  : 'Trading segment',
                                '4'  : 'Upload documents ',
                                '5'  : 'IPV',
                                '6'  : 'ready for verification',
                                '7'  : 'Esign Pending',
                                '8'  : 'Esign Done',
                                '9'  : 'Exchange Punch Pending',
                                '10' : 'registeration complete'
                            };
                            for(let i=0 ; i<=data.data.records.length-1 ; i++){
                                data.data.records[i].step = step_information_list[(data.data.records[i].step).toString()]
                                data.data.records[i].FROM_KRA =  (data.data.records[i].FROM_KRA != undefined && data.data.records[i].FROM_KRA != null) ? (parseInt(data.data.records[i].FROM_KRA) == 1) ? 'kra' : 'Non-kra' : '-'
                                data.data.records[i].created =  moment(data.data.records[i].created, 'DD-MM-YYYY hh:mm:ss')
                                data.data.records[i].country =   (data.data.records[i].country != '' && data.data.records[i].country != null) ? getters[Const.GET_COUNTRY_LIST][(data.data.records[i].country).toString()] : '-'

                                if(i == data.data.records.length-1){
                                    parameter.csvExport(data.data.records, 'Squadiq-data.csv')
                                }
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_ADMIN_CHART_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_CHART_DATA, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    try {
                        parameter.pageLoader = false
                        if ('info' in data) {
                            if (data.info == 'OK') {
                                if (Object.keys(data.data).length > 0) {

                                    commit(Const.SET_ADMIN_REGISTRATION_LINE_DATA, data.data)

                                    // Registration chart data
                                        if ((data.data.REGISTRATATION).length > 0) {
                                            let startDate = moment(inputJson.from_date, 'YYYY-MM-DD')
                                            let endDate = moment(inputJson.to_date, 'YYYY-MM-DD')
                                            let days = endDate.diff(startDate, 'days')
                                            days = days + 1
                                            let finalData = []
                                            for (let i = 0; i < days; i++) {
        
                                                // let date = moment(inputJson.from_date, 'YYYY-MM-DD HH:mm').add(i, 'days')
                                                let date = moment(inputJson.from_date, 'YYYY-MM-DD').add(i, 'days')
                                                date = moment(date).format('YYYY-MM-DD HH:mm')
                                                // obj.date = moment(date).format('DD MMMM')
                                                let obj = {
                                                    date: moment(date).format('DD MMMM'),
                                                }

                                                if((data.data.ACCOUNT_VERIFIED).length > 0){
                                                    let verifiedData = data.data.ACCOUNT_VERIFIED.filter( i => i.date == date)
                                                    if (verifiedData.length && Object.keys(verifiedData[0]).length > 0) {
                                                        obj.verified = parseInt(verifiedData[0].value)
                                                    }
                                                }
                                                if((data.data.ACCOUNT_PENDING).length > 0){
                                                    let pendingData = data.data.ACCOUNT_PENDING.filter(i => i.date == date)
                                                    if (pendingData.length && Object.keys(pendingData[0]).length > 0) {
                                                        obj.pending = parseInt(pendingData[0].value)
                                                    }
                                                }

                                                if((data.data.ESIGN_DONE).length > 0){
                                                    let esign_done = data.data.ESIGN_DONE.filter(i => i.date == date)
                                                    if (esign_done.length && Object.keys(esign_done[0]).length > 0) {
                                                        obj.esign_done = parseInt(esign_done[0].value)
                                                    }
                                                }

                                                let registrationData = data.data.REGISTRATATION.filter(i => {
                                                    return i.date == date
                                                })
                                                if (registrationData.length && Object.keys(registrationData[0]).length > 0) {
                                                    obj.registration = parseInt(registrationData[0].value)
                                                }
                                                    
                                                finalData.push(obj)
        
                                            }
                                                commit(Const.SET_ADMIN_CHART_DATA, finalData)
                                                console.log("dc", inputJson)
                                                if(parameter.type == "bar"){
                                                    if(finalData.length > 0){
                                                        setTimeout(function(){parameter.registerchart()},1000);
                                                    }
                                                }
                                            
                                        }else{
                                            commit(Const.SET_ADMIN_CHART_DATA, [])
                                        }
                                        
                                        // Deposit chart data
                                        if ((data.data.DEPOSIT_ATOM).length > 0) {
                                            let startDate = moment(inputJson.from_date, 'YYYY-MM-DD')
                                            let endDate = moment(inputJson.to_date, 'YYYY-MM-DD')
                                            let days = endDate.diff(startDate, 'days')
                                            days = days + 1
                                            let finalData = []
                                            for (let i = 0; i < days; i++) {
        
                                                // let date = moment(inputJson.from_date, 'YYYY-MM-DD HH:mm').add(i, 'days')
                                                let date = moment(inputJson.from_date, 'YYYY-MM-DD').add(i, 'days')
                                                date = moment(date).format('YYYY-MM-DD HH:mm')
                                                // obj.date = moment(date).format('DD MMMM')
                                                let obj = {
                                                    date: moment(date).format('DD MMMM'),
                                                }

                                                if((data.data.DEPOSIT_NEFT).length > 0){
                                                    let depositneft = data.data.DEPOSIT_NEFT.filter( i => i.date == date)
                                                    if (depositneft.length && Object.keys(depositneft[0]).length > 0) {
                                                        obj.neft = parseInt(depositneft[0].value)
                                                    }
                                                }
                                                if((data.data.DEPOSIT_UPI).length > 0){
                                                    let depositupi = data.data.DEPOSIT_UPI.filter(i => i.date == date)
                                                    if (depositupi.length && Object.keys(depositupi[0]).length > 0) {
                                                        obj.upi = parseInt(depositupi[0].value)
                                                    }
                                                }
                                                    let depositatom = data.data.DEPOSIT_ATOM.filter(i => {
                                                        return i.date == date
                                                    })
                                                    if (depositatom.length && Object.keys(depositatom[0]).length > 0) {
                                                        obj.atom = parseInt(depositatom[0].value)
                                                    }
                                                finalData.push(obj)
        
                                            }
                                            commit(Const.SET_ADMIN_DEPOSIT_DATA, finalData)
                                            if(parameter.type == "bar"){
                                                if(finalData.length > 0){
                                                    setTimeout(function(){parameter.depositchart()},1000);
                                                }
                                            }
                                            
                                        }else{
                                            commit(Const.SET_ADMIN_DEPOSIT_DATA, [])
                                        }

                                        // Withdrawal chart data
                                        // if ((data.data.WITHDRAWAL).length > 0) {
                                        //     let startDate = moment(inputJson.from_date, 'YYYY-MM-DD')
                                        //     let endDate = moment(inputJson.to_date, 'YYYY-MM-DD')
                                        //     let days = endDate.diff(startDate, 'days')
                                        //     days = days + 1
                                        //     let finalData = []
                                        //     for (let i = 0; i < days; i++) {
        
                                        //         // let date = moment(inputJson.from_date, 'YYYY-MM-DD HH:mm').add(i, 'days')
                                        //         let date = moment(inputJson.from_date, 'YYYY-MM-DD').add(i, 'days')
                                        //         date = moment(date).format('YYYY-MM-DD HH:mm')
                                        //         // obj.date = moment(date).format('DD MMMM')
                                        //         let obj = {
                                        //             date: moment(date).format('DD MMMM'),
                                        //         }
                                        //             let withdrawalamount = data.data.WITHDRAWAL.filter(i => {
                                        //                 return i.date == date
                                        //             })
                                        //             if (withdrawalamount.length && Object.keys(withdrawalamount[0]).length > 0) {
                                        //                 obj.withdrawalseries = parseInt(withdrawalamount[0].value)
                                        //             }
                                        //         finalData.push(obj)
        
                                        //     }
                                        //     commit(Const.SET_ADMIN_WITHDRAWAL_DATA, finalData)
                                        //     if(parameter.type == "bar"){
                                        //         if(finalData.length > 0){
                                        //             setTimeout(function(){parameter.withdrawalchart()},1000);
                                        //         }
                                        //     }
                                            
                                        // }else{
                                        //     commit(Const.SET_ADMIN_WITHDRAWAL_DATA, [])
                                        // }

                                        if(parameter.type == "line"){
                                            setTimeout(function(){
                                                parameter.registerlinechart()
                                                parameter.depositlinechart()
                                                //parameter.withdrawallinechart()
                                            },1000);
                                        }
                                        
                                    
    
                                } else {
                                    commit(Const.SET_ADMIN_CHART_DATA, [])
                                    commit(Const.SET_ADMIN_REGISTRATION_LINE_DATA, {})
                                }
                            } else {
                                commit(Const.SET_ADMIN_CHART_DATA, [])
                                parameter.$notify({
                                    group: 'foo',
                                    text: data.msg.responseMessage,
                                    type: 'error'
                                });
                            }
                        }
    
                    } catch(error) {
                        console.log(error)
                    }
                },
                    // e => {
                    // console.log(e); _handleErrorResponse(e, commit)}
                )
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //------------------------- EP GET ADMIN REFERRED LIST -------------------------------------

    [Const.RUN_GET_ADMIN_REFERRED_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader = true
            // alert(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_REFERRED_LIST)
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_ADMIN_REFERRED_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_ADMIN_REFERRED_LIST, data.data)
                        } else {
                            commit(Const.SET_ADMIN_REFERRED_LIST, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        alert('1234'); console.log(e); _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //--------------------------API KEY-------------------------------------

    [Const.RUN_GET_API_KEY_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_API_KEY_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (data.data.length > 0) {
                                commit(Const.SET_API_KEY_LIST, data.data)
                            } else {
                                commit(Const.SET_API_KEY_LIST, [])
                            }
                        } else {
                            commit(Const.SET_API_KEY_LIST, [])
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DISABLE_API_KEY]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const parameter = inputJson.parameter
            delete inputJson.parameter
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DISABLE_API_KEY, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing()
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //--------------------------NOMINEE DATA-------------------------------------

    [Const.RUN_GET_USERS_LIST_FOR_NOMINEE]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_USERS_LIST_FOR_NOMINEE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (inputJson.idArray) {
                                parameter.listing()
                                parameter.csvExport(data.data)
                                parameter.array_verify_sign = []
                            } else {
                                if (data.data.length > 0) {
                                    commit(Const.SET_USERS_LIST_FOR_NOMINEE, data.data)
                                } else {
                                    commit(Const.SET_USERS_LIST_FOR_NOMINEE, [])
                                }
                            }
                        } else {
                            if (inputJson.idArray) { } else {
                                commit(Const.SET_USERS_LIST_FOR_NOMINEE, [])
                            }

                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_NOMINEE_DETAIL]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_NOMINEE_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (data.data.length > 0) {
                                commit(Const.SET_NOMINEE_DETAIL, data.data)
                            } else {
                                commit(Const.SET_NOMINEE_DETAIL, [])
                            }

                        } else {
                            commit(Const.SET_NOMINEE_DETAIL, [])
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_CVL_RESPONSE]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SET_CVL_RESPONSE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_CVL_RESPONSE, data.data)
                        } else {
                            commit(Const.SET_CVL_RESPONSE, {})
                            // parameter.$notify({
                            //     group: 'foo',
                            //     text: data.msg.responseMessage,
                            //     type: 'error'
                            // });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },


    [Const.RUN_GET_CVL_STATUS]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CVL_STATUS, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_CVL_STATUS, data.data)
                        } else {
                            commit(Const.SET_CVL_STATUS, {})
                            // parameter.$notify({
                            //     group: 'foo',
                            //     text: data.msg.responseMessage,
                            //     type: 'error'
                            // });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_PUSH_TO_FTP]({ commit, state, getters, dispatch }, data) {
        return new Promise((resolve, reject) => {
            try {
                let modulee = ''
                const inputJson = data
                const rout = inputJson.rout
                const parameter = inputJson.parameter
                delete inputJson.parameter
                delete inputJson.rout
                parameter.pageLoader = true
                RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_PUSH_TO_FTP, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                    .map(response => response.data)
                    .subscribe(data => {
                        parameter.pageLoader = false
                        if ('info' in data) {
    
                            if (data.info == 'OK') {
                                resolve(true)
                                parameter.$notify({
                                    group: 'foo',
                                    text: 'pushed to FTP successfully',
                                    type: 'success'
                                });
                            } else {
                                reject(false)
                                console.log('error', data)
                                parameter.$notify({
                                    group: 'foo',
                                    text: data.msg,
                                    type: 'error'
                                });
                            }
                        }
                        
                    },
                        e => { _handleErrorResponse(e, commit) })
            } catch (ex) { 
                reject(false);
                _handleErrorResponse(ex, commit) 
            }
		});
        
    },
    //------------------------------CREATE ADMIN--------------------------------------------

    [Const.RUN_CREATE_ADMIN]({ commit, state, getters, dispatch }, credentials) {
        try {
            credentials.localParams.parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CREATE_ADMIN, credentials.globalParams, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    credentials.localParams.parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {

                            credentials.localParams.parameter.reset()
                            credentials.localParams.parameter.api_response = data.data
                            /*credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: 'New Admin Created Successfully',
                                type: 'success'
                            });*/
                        } else {
                            credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },


    [Const.RUN_GET_COUPON_LISTING]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_COUPON_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (data.data.length > 0) {
                                for (let i = 0; i <= data.data.length - 1; i++) {
                                    if (parseInt(data.data[i].is_reedemed) == 0 && parseInt(data.data[i].processed_coupon_req) == 0) {
                                        parameter.showCsvBtn = true
                                    }

                                    if (i == data.data.length - 1) {
                                        parameter.coupon_list = data.data
                                        parameter.totalRecords = ((data.data[0].totalRecords == null) ? 0 : data.data[0].totalRecords);
                                    }
                                }
                            } else {
                                parameter.coupon_list = []
                                parameter.totalRecords = 0
                            }
                        } else {
                            parameter.coupon_list = []
                            parameter.totalRecords = 0
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_COUPON_CSV_FILE]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_CSV_FILE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (data.data.length > 0) {
                                parameter.csvExport(data.data)
                                parameter.listing()
                            } else {
                                parameter.$notify({
                                    group: 'foo',
                                    text: 'no record found',
                                    type: 'error'
                                });
                            }

                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_COUPON_EMAIL_SENT]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_EMAIL_SENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing()
                            parameter.$notify({
                                group: 'foo',
                                text: 'Email sent successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_COUPON_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_COUPON_DOCUMENT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    parameter.$refs.doc.value = ''
                    parameter.reset()
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }

                    }

                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //-----------------------------------debit-list------------------------------------
    [Const.RUN_DEBIT_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DEBIT_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if (modulee != 'csv') { parameter.pageLoader1 = false }
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_DEBIT_LIST, data.data)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_GET_PAN_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_PAN_DATA, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {    parameter.$parent.pageLoader= false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_PAN_DATA, data.data)
                        } else {
                            commit(Const.SET_PAN_DATA, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg.responseMessage,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADD_CLIENT_CODE_DEBIT_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.para_loader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_CLIENT_CODE_DEBIT_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if (modulee != 'csv') { parameter.para_loader = false }
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.listing('1')
                            parameter.array_payment = []
                            parameter.atom_array = []
                            parameter.ignore_array = []
                            parameter.bnk_array = []
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //-----------------------------------rising-reconcilation-list------------------------------------
    [Const.RUN_RISING_RECONCILATION_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RISING_RECONCILATION_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if (modulee != 'csv') { parameter.pageLoader1 = false }
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_RISING_RECONCILATION_LIST, data.data)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //-----------------------------------stagging-rising-list----------------------------------
    [Const.RUN_STAGGING_RISING_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            let modulee = ''
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            modulee = inputJson.module
            delete inputJson.module
            if (modulee != 'csv') {
                parameter.pageLoader1 = true
            }
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_STAGGING_RISING_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if (modulee != 'csv') { parameter.pageLoader1 = false }
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if (modulee != '' && modulee == 'csv') {
                                commit(Const.SET_STAGGING_RISING_LIST_CSV, data.data)
                                parameter.csvExport('download-list.csv')
                            } else {
                                commit(Const.SET_STAGGING_RISING_LIST, data.data)
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_STAGGING_RISING_UPDATE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_STAGGING_RISING_UPDATE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.array_verify_sign = []
                            parameter.listing()
                            parameter.$notify({
                                group: 'foo',
                                text: 'update data successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    //-----------------------knowledge-------------------------------

    [Const.RUN_GET_CAT_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.localParams.parameter
            if ('page' in inputJson.localParams) {
                parameter.pageLoader = true
            }
            delete inputJson.localParams
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CAT_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_CAT_LIST, data.data)
                        } else {
                            commit(Const.SET_CAT_LIST, [])
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },


    [Const.RUN_CREATE_CATEGORY]({ commit, state, getters, dispatch }, data) {
        _executeApi(Enpoints.EP_CREATE_CATEGORY, data, data.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (data.localParams.module == 'edit') {
                    data.localParams.parameter.$router.push({ path: '/category-list' })
                    _messageDisplayFunction(data.localParams.parameter, 'edit category successfully', 'success')
                } else {
                    data.localParams.parameter.reset()
                    _messageDisplayFunction(data.localParams.parameter, 'create category successfully', 'success')
                }
            } else {
                if (data.localParams.module != 'edit') {
                    data.localParams.parameter.reset()
                }
                _messageDisplayFunction(data.localParams.parameter, result.res_data, 'error')
            }
        })
    },


    [Const.RUN_CREATE_ARTICLE]({ commit, state, getters, dispatch }, data) {
        _executeApi(Enpoints.EP_CREATE_ARTICLE, data, data.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (data.localParams.module == 'edit') {
                    data.localParams.parameter.$router.push({ path: '/articles-list' })
                    _messageDisplayFunction(data.localParams.parameter, 'edit article successfully', 'success')
                } else {
                    data.localParams.parameter.reset()
                    _messageDisplayFunction(data.localParams.parameter, 'create article successfully', 'success')
                }
            } else {
                if (data.localParams.module != 'edit') {
                    data.localParams.parameter.reset()
                }
                _messageDisplayFunction(data.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_GET_ARTICLE_LIST]({ commit, state, getters, dispatch }, data) {
        _executeApi(Enpoints.EP_GET_ARTICLE_LIST, data, data.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_ARTICLE_LIST, result.res_data)
            } else {
                commit(Const.SET_ARTICLE_LIST, [])
                _messageDisplayFunction(data.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    [Const.RUN_GET_ARTICLE_DETAIL]({ commit, state, getters, dispatch }, data) {
        _executeApi(Enpoints.EP_GET_ARTICLE_DETAIL, data, data.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                data.localParams.parameter.art_name = result.res_data[0].articleName
                data.localParams.parameter.art_desc = result.res_data[0].description
                data.localParams.parameter.categoryId = result.res_data[0].categoryId
                data.localParams.parameter.category = result.res_data[0].catSlug
                data.localParams.parameter.status = result.res_data[0].status
            } else {
                _messageDisplayFunction(data.localParams.parameter, result.res_data, 'error')
            }
        })
    },


    [Const.RUN_GET_CAT_DETAIL]({ commit, state, getters, dispatch }, data) {
        _executeApi(Enpoints.EP_GET_CAT_DETAIL, data, data.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                data.localParams.parameter.cat_name = result.res_data[0].name
                data.localParams.parameter.cat_desc = result.res_data[0].description
                data.localParams.parameter.status = result.res_data[0].status
            } else {
                _messageDisplayFunction(data.localParams.parameter, result.res_data, 'error')
            }
        })
    },


    /*[Const.RUN_GET_CAT_DETAIL]({commit, state,getters,dispatch}, data){   
        try {
            const inputJson = data
            const parameter = inputJson.localParams.parameter
            if('page1' in inputJson.localParams){
             parameter.pageLoader = false
            }
            delete inputJson.localParams
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_CAT_DETAIL, data, {'Authorization': 'Bearer ' + getters.GET_TOKEN})
            .map(response => response.data)
            .subscribe(data => 
            {   parameter.pageLoader = false
                if('info' in data){
                    if (data.info == 'OK') {
                        console.log(data.data[0])
                        parameter.cat_name = data.data[0].name
                        parameter.cat_desc = data.data[0].description
                        parameter.status = data.data[0].status
                    }else{
                        parameter.$notify({
                            group: 'foo',
                            text: data.msg,
                            type: 'error'
                        }); 
                    }
                }
            },
            e => { _handleErrorResponse(e, commit)})
        } catch(ex){ _handleErrorResponse(ex, commit) }

    },*/




    //------------------------------------edit profile image-----------------------------------
    [Const.RUN_EDIT_PROFILE_IMAGE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_EDIT_PROFILE_IMAGE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            let json = getters[Const.GET_NEW_REGISTERATIONS]
                            json.result[0].passport_image = data.data.filename
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_NEW_REGISTERATIONS, json)
                            parameter.ishidden()
                            parameter.$notify({
                                group: 'foo',
                                text: 'profile pic update successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //----------------------------------demat pending api---------------------------------------
    [Const.RUN_DEMAT_PENDING_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DEMAT_PENDING_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_DEMAT_PENDING_LIST, data.data)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADD_DEMAT_DETAILS]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_DEMAT_DETAILS, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.addDematModal = false
                            parameter.$notify({
                                group: 'foo',
                                text: 'change detail successfully',
                                type: 'success'
                            });
                            //commit(Const.SET_DEMAT_PENDING_LIST, data.data)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_EDIT_TICKET]({ commit, state, getters, dispatch }, credentials) {
        try {
            credentials.localParams.parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADD_EDIT_TICKET, credentials.globalParams, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    credentials.localParams.parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            credentials.localParams.parameter.edit_ticket = false
                            credentials.localParams.parameter.viewTicket('')

                            credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: 'update user address detail successfully',
                                type: 'success'
                            });
                        } else {
                            credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },


    //------------------------------change-password--------------------------------------------

    [Const.RUN_CHANGE_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
        try {
            credentials.localParams.parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHANGE_PASSWORD, credentials.globalParams, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    credentials.localParams.parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {

                            credentials.localParams.parameter.reset()
                            credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: 'password change Successfully',
                                type: 'success'
                            });
                        } else {
                            credentials.localParams.parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },


    //==================================categorisation user api=================================
    [Const.RUN_EXCHANGE_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_EXCHANGE_DATA, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (inputJson.exchange == '2') {
                                let i, ncdex_json = {}, ncdex_array = [];
                                let category_json = { "BARLEY": "BARLEYJPR", "CASTOR SEED": "CASTOR", "CHANA": "CHANA", "COTTON SEED OILCAKE": "COCUDAKL", "29 MM COTTON": "COTTON", "CRUDE PALM OIL": "CPO", "CORIANDER": "DHANIYA", "GUAR GUM": "GUARGUM5", "GUAR SEED 10 MT": "GUARSEED10", "JEERA": "JEERAUNJHA", "KAPAS": "KAPAS", "MAIZE KHARIF/SOUTH": "MAIZEKHRIF", "MAIZE RABI": "MAIZERABI", "MOONG": "MOONG", "PADDY (BASMATI) - PUSA 1121": "PADYPB11", "MUSTARD SEED": "RMSEED", "SUGAR M": "SUGARM", "SOYBEAN": "SYBEANIDR", "REFINED SOY OIL": "SYOREF", "TURMERIC": "TMCFGRNZM", "WHEAT": "WHEATFAQ" }
                                for (i = 0; i <= data.data.length - 1; i++) {
                                    ncdex_json = {}
                                    let cat_name = (data.data[i].category_name && data.data[i].category_name != '' && data.data[i].category_name != null) ? category_json[data.data[i].category_name.toUpperCase().trim()] : '';
                                    ncdex_json['Member ID'] = data.data[i].id
                                    ncdex_json['Client ID'] = data.data[i].client_code
                                    ncdex_json['Symbol'] = cat_name
                                    ncdex_json['Category'] = data.data[i].category_option
                                    ncdex_array.push(ncdex_json)
                                }
                                if (i == data.data.length) {
                                    //console.log('ncdex_array---------',ncdex_array)
                                    parameter.ncdex_data = ncdex_array
                                    parameter.file_name = "ncdex-file.csv"
                                    parameter.csvExport(ncdex_array)
                                }

                            } else {
                                let mcx_json = {}; let mcx_array = []; let outercount = 0
                                for (var key in data.data) {
                                    let count = 0; outercount++; mcx_json = {}
                                    mcx_json.clientCode = key
                                    for (var innerkey in data.data[key]) {
                                        count++
                                        for (var innerinnerkey in data.data[key][innerkey]) {
                                            mcx_json[innerinnerkey] = data.data[key][innerkey][innerinnerkey]
                                        }
                                    }
                                    if (count == Object.keys(data.data[key]).length) {
                                        mcx_json[',,,,,,,,'] = ',,,,,,,,'
                                        mcx_array.push(mcx_json)
                                    }
                                }
                                if (outercount == Object.keys(data.data).length) {
                                    parameter.mcx_data = mcx_array
                                    parameter.file_name = "mcx-file.txt"
                                    parameter.csvExport(mcx_array)
                                }
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CATEGORISATION_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CATEGORISATION_USER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            commit(Const.SET_CATEGORISATION_USER_LIST, data.data)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CATEGORISATION_USER_DETAIL]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CATEGORISATION_USER_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {

                            localStorage.setItem("categorisation_detail", JSON.stringify(data.data));
                            commit(Const.SET_CATEGORISATION_USER_DETAIL, data.data)
                            rout.replace('/categorisation-detail')
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    // CVL Status
    [Const.RUN_CVL_STATUS_LISTING]({ commit, state, dispatch, getters }, request) {
        try {
            request.parameter.pageLoader = true
            let fetchAllData = request.payload.getFullRecords ? true : false;
            const filters = request.payload.filter;
            const filterDataForCSV = (records = []) => {
                let tempList = [];
                let toExport = records.records;
                 if (filters.source != '') {
                    toExport = toExport.filter(r => {
                    let srcKey;
                    switch ((r.source || "").toLowerCase()) {
                        case "shoonya App":
                        srcKey = "shoonya_app";
                        break;
                        case "jumpp app":
                        srcKey = "jumpp_app";
                        break;
                        case "jumpp":
                        srcKey = "jumpp";
                        case "":
                        srcKey = "finvasia";
                        break;
                        default:
                        srcKey = r.source.toLowerCase().replace(/\s+/g, "_");
                    }
                    return srcKey === filters.source;
                    });
                }

                 if (filters.cvltype != '') {
                    toExport = toExport.filter(r => 
                    String(r.cvl_code).toLowerCase() === String(filters.cvltype).toLowerCase()
                    );
                }
                toExport.map((val, count) => {
                    tempList.push({
                        Name: val.username || '',
                        ClientCode: val.client_code || '',
						PAN: val.pan_no,
                        "Old Status": val.cvl_previous_status != null ? val.cvl_previous_status : '',
                        "New Status": val.status || '',
                        Source: val.source || '',
						Type: val.cvl_code || '',
                        Created: val.created || '',
                        "Last Updated On": val.last_updated_on || '',
                        Reason: val.reason || '',
                    })
                })
                if(tempList.length) {

                    let csvContent = "data:text/csv;charset=utf-8,";
                    csvContent += [
                    Object.keys(tempList[0]).join(","),
                    ...tempList.map(item => Object.values(item).join(","))
                    ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");
                    const data = encodeURI(csvContent);
                    const link = document.createElement("a");
                    link.setAttribute("href", data);
                    link.setAttribute("download", `cvl-status-list.csv`);
                    link.click();
                }
            }
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CVL_STATUS_LISTING, request.payload, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    request.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if(fetchAllData){
                                filterDataForCSV(data.data);
                                return
                            }
                            commit(Const.SET_CVL_STATUS_LIST, data.data)
                        } else {
                            if(fetchAllData){
                                filterDataForCSV(data.data)
                                return
                            }
                            commit(Const.SET_CVL_STATUS_LIST, {records: [], total: 0})
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },    
    [Const.RUN_CVL_RESPONSE_LISTING]({ commit, getters }, request) {
        try {
            request.parameter.pageLoader = true
            let fetchAllData = request.payload.getFullRecords ? true : false;
            const filterDataForCSV = (records = []) => {
                let tempList = [];
                records.records.map((val, count) => {
                    tempList.push({
                        Name: val.username || '',
                        ClientCode: val.client_code || '',
						PAN: val.pan_no,
                        Status: val.status || '',
						Type: val.cvl_code || '',
                        Created: val.created || '',
                        Last_Updated_On: val.last_updated_on || '',
                        Reason: val.reason || '',
                    })
                })
                let csvContent = "data:text/csv;charset=utf-8,";
				csvContent += [
				Object.keys(tempList[0]).join(","),
				...tempList.map(item => Object.values(item).join(","))
				]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");
				const data = encodeURI(csvContent);
				const link = document.createElement("a");
				link.setAttribute("href", data);
				link.setAttribute("download", `cvl-response-status-list.csv`);
				link.click();
            }
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CVL_RESPONSE_LISTING, request.payload, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    request.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            if(fetchAllData){
                                filterDataForCSV(data.data);
                                return
                            }
                            commit(Const.SET_CVL_RESPONSE_LIST, data.data)
                        } else {
                            if(fetchAllData){
                                filterDataForCSV(data.data);
                                return
                            }
                            commit(Const.SET_CVL_RESPONSE_LIST, {records: [], total: 0})
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },    
    //==================================Rm Pending user api=================================
    [Const.RUN_RM_ADD_COMMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RM_ADD_COMMENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.rmAddCommentModal = false
                            parameter.$notify({
                                group: 'foo',
                                text: "Add comment Succesfully",
                                type: 'success'
                            });
                            dispatch(Const.RUN_NEW_REGISTERATIONS_VIEW, { "id": inputJson.user_id, "rout": rout, "parameter": parameter, "pageName": "/rm-view" });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RM_VERIFY_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RM_VERIFY_USER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "user verify Succesfully",
                                type: 'success'
                            });
                            rout.replace('/rm-pending-registeration')
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RM_UPLOAD_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RM_UPLOAD_DOCUMENT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                            dispatch(Const.RUN_NEW_REGISTERATIONS_VIEW, { "id": inputJson.id, "rout": rout, "parameter": parameter, "pageName": "/rm-view" });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //=============================Pending and Rm user view api==============================
    [Const.RUN_SWITCH_NON_KRA]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SWITCH_NON_KRA, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "User successfully switch to non-kra!",
                                type: 'success'
                            });
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            json.result[0].user.FROM_KRA = 0
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //============================complete esign new Rm user view api ========================
    [Const.RUN_NEW_REGISTERATIONS_VIEW]({ commit, state, getters }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            const pageName = inputJson.pageName
            delete inputJson.pageName
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_VIEW_ADMIN_USER_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (data.data.docs.length > 0) {
                                let j;
                                for (j = 0; j <= data.data.docs.length - 1; j++) {
                                    //let img_name = data.data.docs[j].document.split('.')
                                    let getjsonData = _getImgeNameExntension(data.data.docs[j].document)
                                    data.data.docs[j].imgName = getjsonData.docName
                                    data.data.docs[j].extension = getjsonData.extension
                                }

                                if (j == data.data.docs.length) {
                                    localStorage.setItem("new_registerations", JSON.stringify(data.data));
                                    commit(Const.SET_NEW_REGISTERATIONS, data.data)
                                    parameter.fetchPanData('')
                                    rout.push({ path: pageName, query: { "Id": inputJson.id } })

                                }
                            } else {
                                localStorage.setItem("new_registerations", JSON.stringify(data.data));
                                commit(Const.SET_NEW_REGISTERATIONS, data.data)
                                parameter.fetchPanData('')
                                rout.push({ path: pageName, query: { "Id": inputJson.id } })

                            }

                        }
                        else {
                            commit(Const.SET_PAN_DATA, {})
                            commit(Const.SET_NEW_REGISTERATIONS, {})
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //==================for search user only========================================================
    [Const.RUN_CHANGE_NEST_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHANGE_NEST_USER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'nest user change successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RESET_PASSWORD]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RESET_PASSWORD, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'reset password successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RESET_QUES_ANS]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RESET_QUESTION_ANSWER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'reset question answer successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_BACKSTAGE_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_BACKSTAGE_USER, inputJson, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            const successMsg = (typeof data.msg === 'string' && data.msg !== '') ? data.msg : 'User moved to backstage successfully'
                            parameter.$notify({
                                group: 'foo',
                                text: "User Backstaged Successfully",
                                type: 'success'
                            });
                            parameter.backstageReason = ''
                            parameter.backstageUserModal = false
                            parameter.reloadPageData()

                            // if (inputJson.user_id) {
                            //     parameter.viewUserDetail(inputJson.user_id)
                            // }
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => {
                        parameter.$parent.pageLoader = false
                        _handleErrorResponse(e, commit)
                    })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    //=================new Pending rm esign complete search user list api===========================
    [Const.RUN_LEAD_USER_LISTING]({ commit, state, getters, dispatch }, data) {
        return new Promise((resolve, reject) => {

            try {
                let user_types = '';
                const inputJson = data
                const rout = inputJson.rout
                const parameter = inputJson.parameter
                delete inputJson.parameter
                delete inputJson.rout

                parameter.pageLoader1 = true
                RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_LEAD_USER_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                    .subscribe(data => {
                        parameter.pageLoader1 = false
                        const payload = data.data;  
                        if ('info' in payload) {
                            if (payload.info === 'OK') {
                                const recContainer = payload.data;
                                const arr = recContainer.records;
                                commit(Const.SET_LEAD_USER_LISTING, arr)
                                if(inputJson.download != undefined && inputJson.download == true){
                                parameter.ksCsvExport(arr.records) 
                                parameter.download = false
                                }
                                resolve(arr);
                            } else {
                                commit(Const.SET_LEAD_USER_LISTING, {})
                                parameter.$notify({
                                    group: 'foo',
                                    text: data.msg,
                                    type: 'error'
                                });
                            }
                        }
                    },
                        e => { _handleErrorResponse(e, commit) })
            } catch (ex) { _handleErrorResponse(ex, commit) }
        });
    },
    [Const.RUN_ADMIN_USER_LISTING]({ commit, state, getters, dispatch }, data) {
        try {
             let user_types = '';
            const inputJson = data
            const rout = inputJson.rout
            let fetchAllData = inputJson.all ? true : false;
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout

            //============for search user only=============
            const page_name = inputJson.page_name
            delete inputJson.page_name
            //============for pending user only============
            if (inputJson.user_type) {
                user_types = inputJson.user_type
                delete inputJson.user_type
            }
            //========for categorisation user only=========
            if (inputJson.date_filter) {
                user_types = inputJson.date_filter
                delete inputJson.date_filter
            }

            // const filterDataForCSV = (records = []) => {
            //     let tempList = [];
            //     let toExport = records.records;

            //     if (inputJson.ipv_source) {
            //         toExport = toExport.filter(r => {
            //         let srcKey;
            //         switch ((r.source || "").toLowerCase()) {
            //             case "shoonya app":
            //             srcKey = "shoonya_app";
            //             break;
            //             case "jumpp":
            //             srcKey = "jumpp";
            //             break;
            //             case "":
            //             srcKey = "finvasia";
            //             break;
            //             default:
            //             srcKey = r.source.toLowerCase().replace(/\s+/g, "_");
            //         }
            //         return srcKey === inputJson.ipv_source;
            //         });
            //     }
            //       if (inputJson.from_kra !== undefined && inputJson.from_kra !== "") {
            //         toExport = toExport.filter(r =>
            //         String(r["FROM_KRA"]) === String(inputJson.from_kra)
            //         );
            //     }

            //     if (inputJson.isHoldParam !== undefined && inputJson.isHoldParam !== "") {
            //         toExport = toExport.filter(r =>
            //         String(r.is_hold_user) === String(inputJson.isHoldParam)
            //         );
            //     }
            //     toExport.map((val, count) => {
            //         tempList.push({
            //             UserName: val.username || '',
            //             Email: val.email || '',
            //             ClientCode: val.client_code || '',
            //             Source: val.source || '',
            //             Created: val.created || '',
            //             id: val.id || '',
            //             MobileNumber: val.mobile_no || '',
            //             Pan: val.pan_no || '',
            //             reason: val.reasonText || '',
            //         })
            //     })
            //     let csvContent = "data:text/csv;charset=utf-8,";
            //     if(tempList.length) {

            //         csvContent += [
            //         Object.keys(tempList[0]).join(","),
            //         ...tempList.map(item => Object.values(item).join(","))
            //         ]
            //         .join("\n")
            //         .replace(/(^\[)|(\]$)/gm, "");
            //         const data = encodeURI(csvContent);
            //         const link = document.createElement("a");
            //         link.setAttribute("href", data);
            //         link.setAttribute("download", `user-data-${inputJson.status === 'exchange' ? 'complete' : inputJson.status}.csv`);
            //         link.click();
            //     }
            // }

            const filterDataForCSV = (records = []) => {
                let tempList = [];
                let toExport = records.records;
                if (inputJson.ipv_source) {
                    toExport = toExport.filter(r => {
                    let srcKey;
                    switch ((r.source || "").toLowerCase()) {
                        case "shoonya app":
                        srcKey = "shoonya_app";
                        break;
                        case "jumpp app":
                        srcKey = "jumpp";
                        break;
                        case "jumpp":
                        srcKey = "jumpp";
                        case "":
                        srcKey = "finvasia";
                        break;
                        default:
                        srcKey = r.source.toLowerCase().replace(/\s+/g, "_");
                    }
                    return srcKey === inputJson.ipv_source;
                    });
                }

                toExport.map((val) => {

                    if (inputJson.status === 'backstage') {

                        tempList.push({
                            Username: val.username || '',
                            Email: val.email || '',
                            ClientCode: val.client_code || '',
                            MobileNumber: val.mobile_no || '',
                            BackstageReason: val.hv_backstage_reason || '-',
                            BackstageDate: val.hv_backstage_date 
                            ? moment(val.hv_backstage_date).format("DD-MM-YYYY")
                            : '',
                            TransactionId: val.transaction_id || '-',
                            Source: val.source || '-',
                            Created: val.created 
                            ? moment(val.created).format("DD-MM-YYYY")
                            : '',
                        });

                    } else {

                        tempList.push({
                            UserName: val.username || '',
                            Email: val.email || '',
                            ClientCode: val.client_code || '',
                            Source: val.source || 'Finvasia',
                            Created: val.created || '',
                            id: val.id || '',
                            MobileNumber: val.mobile_no || '',
                            Pan: val.pan_no || '',
                            reason: val.reasonText || '',
                        });

                    }
                });

                let csvContent = "data:text/csv;charset=utf-8,";

                if(tempList.length) {
                    csvContent += [
                    Object.keys(tempList[0]).join(","),
                    ...tempList.map(item => Object.values(item).join(","))
                    ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");
                    const data = encodeURI(csvContent);
                    const link = document.createElement("a");
                    link.setAttribute("href", data);
                    link.setAttribute("download", `user-data-${inputJson.status === 'exchange' ? 'complete' : inputJson.status}.csv`);
                    link.click();
                }
            }

            let user_listing_filter = { "page_number": inputJson.page, "gerUserSearch": inputJson.search, "Userparameter": inputJson.user_types }
            
            parameter.pageLoader1 = true
            let API_PATH;

            if (inputJson.isCSVDownload === true) {
                // Exceptional case (backend requirement)
                API_PATH = Enpoints.EP_ADMIN_USER_LISTING;
            } else {
                API_PATH = fetchAllData
                    ? Enpoints.EP_ADMIN_USER_LISTING_ALL
                    : Enpoints.EP_ADMIN_USER_LISTING;
            }


            RxFactory.post(Enpoints.BASE_URL  + API_PATH , data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let reason_value = ""; let i; let j; let k;
                            let hold_reason_list = getters[Const.GET_HOLD_REASON_LIST];
                            let valueLeafData = {'records' : [], 'total_records' : 0};

                            for (i = 0; i <= data.data.records.length - 1; i++) {
                                reason_value = ""
                                if (data.data.records[i].hold_reason != "" && parseInt(data.data.records[i].hold_reason) != 0) {
                                    let reasonList = data.data.records[i].hold_reason.split(',')
                                    for (k = 0; k <= reasonList.length - 1; k++) {
                                        for (j = 0; j <= hold_reason_list.length - 1; j++) {
                                            if (hold_reason_list[j].id == reasonList[k]) {
                                                reason_value = hold_reason_list[j].reason.toLowerCase() + "<br>" + reason_value
                                            }
                                        }
                                    }
                                    if (k == reasonList.length) {
                                        reason_value = reason_value.substring(0, reason_value.length - 1)
                                        if (data.data.records[i].hold_text != '') {
                                            data.data.records[i].reasonText = reason_value + "<br>," + data.data.records[i].hold_text
                                        } else {
                                            data.data.records[i].reasonText = reason_value
                                        }
                                    }
                                } else {
                                    if (data.data.records[i].hold_text != '') {
                                        data.data.records[i].reasonText = data.data.records[i].hold_text
                                    } else {
                                        data.data.records[i].reasonText = ""
                                    }
                                }

                                if(inputJson.source && inputJson.source != undefined){
                                    valueLeafData.records.push(data.data.records[i])
                                }

                            }
                            // if (i == data.data.records.length) {
                            //     console.log(data.data)
                            //     if (page_name) {
                            //         parameter.admin_user_lists = data.data
                            //     }else if(inputJson.source && inputJson.source != undefined && inputJson.source == 'valueleaf'){
                            //         valueLeafData.total_records = data.data.total_records
                            //         if(exportCsv){
                            //             filterDataForCSV(valueLeafData);
                            //             return
                            //         }
                            //         commit(Const.SET_ADMIN_USER_LISTING, valueLeafData)
                            //     } else {
                            //         if(fetchAllData){
                            //             filterDataForCSV(data.data)
                            //             return
                            //         }

                            //         localStorage.setItem("user_detail_view_filter", JSON.stringify(user_listing_filter));
                            //         commit(Const.SET_ADMIN_USER_LISTING, data.data)
                            //     }
                            //     //localStorage.setItem("pending_user", JSON.stringify(support_view_data));
                            // }
                             if (i == data.data.records.length) {
                                console.log(data.data)
                                if (page_name) {
                                    parameter.admin_user_lists = data.data
                                }else if(inputJson.source && inputJson.source != undefined && inputJson.source == 'valueleaf'){
                                    valueLeafData.total_records = data.data.total_records
                                    if(fetchAllData || inputJson.isCSVDownload === true){

                                        filterDataForCSV(valueLeafData);
                                        return
                                    }
                                    commit(Const.SET_ADMIN_USER_LISTING, valueLeafData)
                                } else {
                                    if(fetchAllData || inputJson.isCSVDownload === true){

                                        filterDataForCSV(data.data)
                                        return
                                    }
                                    localStorage.setItem("user_detail_view_filter", JSON.stringify(user_listing_filter));
                                    commit(Const.SET_ADMIN_USER_LISTING, data.data)
                                }
                                //localStorage.setItem("pending_user", JSON.stringify(support_view_data));
                            }


                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },
    [Const.RUN_GROSS_INCOME_USER_LISTING]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data;
            const parameter = inputJson.parameter;
            delete inputJson.parameter;
            parameter.pageLoader1 = true;
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GROSS_INCOME_USER_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false;
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (inputJson.isCSVDownload) {
                                parameter.csvData = data.data;   
                                return
                            }

                            // if (data.info === 'OK') {
                            
                            //     commit(Const.SET_GROSS_INCOME_LIST, {
                            //         payload: {
                            //         records: data.data.list || [],
                            //         total_records: data.data.totalRecords || 0
                            //         }
                            //     });


                                
                            // }

                        //       if (!inputJson.isCSVDownload) {
                        //         commit(Const.SET_GROSS_INCOME_LIST, {
                        //             payload: {
                        //             records: data.data.list || [],
                        //             total_records: data.data.totalRecords || 0
                        //             }
                        //         });
                        //          resolve(data.data);
                        //     }

                            
                           commit(Const.SET_GROSS_INCOME_LIST, {
                            payload: {
                                records: data.data.list || [],
                                total_records: data.data.totalRecords || 0
                            }
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });

                            commit(Const.SET_GROSS_INCOME_LIST, {
                                payload: {
                                    records: data.data.list || [],
                                    total_records: data.data.totalRecords || 0
                                }
                                });
                            // parameter.pageLoader1 = true;
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },
    [Const.RUN_HYPERVERGE_USER_LISTING]({ commit, state, getters, dispatch }, data) {
              try {
            const inputJson = data;
            const parameter = inputJson.parameter;
            delete inputJson.parameter;
            parameter.pageLoader1 = true;
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_HYPERVERGE_USER_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false;
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            console.log(data)
                            if (inputJson.isCSVDownload) {
                                    parameter.csvData = {
                                        records: data.data.list || []
                                    };
                                    return
                                }
                           commit(Const.SET_HYPERVERGE_LIST, {
                            payload: {
                                records: data.data.list || [],
                                total_records: data.data.totalRecords || 0
                            }
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });

                            commit(Const.SET_HYPERVERGE_LIST, {
                                payload: {
                                    records: data.data.list || [],
                                    total_records: data.data.totalRecords || 0
                                }
                                });
                            // parameter.pageLoader1 = true;
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }

    },
    // PAN NUMBER
    [Const.RUN_PAN_NUMBER_LISTING]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data;
            const parameter = inputJson.parameter;
            delete inputJson.parameter;
            parameter.pageLoader1 = true;
            RxFactory.post(Enpoints.BASE_URL + Enpoints.PAN_NUMBER_LISTING, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false;
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.pan_number_lists = data.data
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                            parameter.pan_number_lists.records = [];
                            parameter.pan_number_lists.count = 0;
                            // parameter.pageLoader1 = true;
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    // PAN FETCH DIGIO
    [Const.RUN_PAN_DETAILS_DIGITAP]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data;
            const rout = inputJson.rout
            const parameter = inputJson.parameter;
            delete inputJson.parameter;
            delete inputJson.rout;
            const type = inputJson.type;
            delete inputJson.type;
            parameter.pageLoader1 = true;
            if(type && type == 'refetch') {
                parameter.type_ = true;
            }

            RxFactory.post(Enpoints.BASE_URL + Enpoints.PAN_FETCH_DIGITAP, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false;
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            // if(parameter.type_) {
                                
                                commit(Const.SET_PAN_DATA, data.data)
                                parameter.refetch_pan_data = data.data
                            // }   
                            // else {
                                parameter.pan_number_lists = data.data
                            // }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                            if(type && type == 'refetch') {
                                commit(Const.SET_PAN_DATA, {})
                                parameter.refetch_pan_data = data.data
                               
                                
                            } else {

                                parameter.pan_number_lists = {}
                            }
                            // parameter.pageLoader1 = true;
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    // PAN NUMBER END
    //=====================================Pending user api==================================
    [Const.RUN_USER_UPDATE_CLIENT_CODE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_UPDATE_CLIENT_CODE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'client code update successfully',
                                type: 'success'
                            });
                            parameter.reset_clientCode()
                            parameter.viewUserDetail(inputJson.user_id)
                        } else {
                            parameter.reset_clientCode()
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_IS_USER_VERIFY]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            let checked = inputJson.checked
            delete inputJson.checked
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_IS_USER_VERIFY, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'user verify successfully',
                                type: 'success'
                            });
                            parameter.viewUserDetail(inputJson.user_id)
                        } else {
                            parameter.checked = checked
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_STEP_SKIP_API]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_STEP_SKIP_API, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (inputJson.type == '') {
                                // if (parameter.reason_for_create_ticket.ipv) {
                                    // parameter.reason_for_create_ticket['bank'] = ''
                                    // parameter.reason_for_create_ticket['cms'] = ''
                                    // parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    // let base_message = "Hi " + parameter.username + '<br>'
                                    // base_message = base_message + " - As the IPV video you had made is not acceptable as per compliance, our customer support executive will be in touch with you regarding the same." + '<br>'
                                    // let inputjson1 = {
                                    //     "reason": 18,
                                    //     "comment": base_message,
                                    //     "user_id": inputJson.user_id,
                                    //     "type": 'ipv',
                                    //     "rout": rout,
                                    //     "parameter": parameter
                                    // }
                                    // dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                // }else 
                                    if (parameter.reason_for_create_ticket.address) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 19,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'address',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                }else if (parameter.reason_for_create_ticket.nominee) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your nominee address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 23,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'nominee',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                }else {
                                    parameter.reason_for_create_ticket = { 'bank': '', 'cms': '', 'cancel_cheque': '', 'ipv': '', 'address': '', 'nominee' : '', 'hold_user' : ''}
                                    parameter.createTicketModal = false
                                    parameter.createTicket('list')
                                }
                            } else if (inputJson.type != '' && inputJson.type == 'address') {
                                // if (parameter.reason_for_create_ticket.ipv) {
                                    // parameter.reason_for_create_ticket['bank'] = ''
                                    // parameter.reason_for_create_ticket['cms'] = ''
                                    // parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    // let base_message = "Hi " + parameter.username + '<br>'
                                    // base_message = base_message + " - As the IPV video you had made is not acceptable as per compliance, our customer support executive will be in touch with you regarding the same." + '<br>'
                                    // let inputjson1 = {
                                    //     "reason": 18,
                                    //     "comment": base_message,
                                    //     "user_id": inputJson.user_id,
                                    //     "type": 'ipv',
                                    //     "rout": rout,
                                    //     "parameter": parameter
                                    // }
                                    // dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                // }else
                                 if (parameter.reason_for_create_ticket.nominee) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your nominee address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 23,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'nominee',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                }else {
                                    parameter.createTicketModal = false
                                    parameter.reason_for_create_ticket['address'] = ''
                                    parameter.createTicket('list')
                                }
                            } else if (inputJson.type != '' && inputJson.type == 'ipv') {
                                if (parameter.reason_for_create_ticket.address) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 19,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'address',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                }else if (parameter.reason_for_create_ticket.nominee) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your nominee address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 23,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'nominee',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                } else {
                                    parameter.createTicketModal = false
                                    parameter.reason_for_create_ticket['ipv'] = ''
                                    parameter.createTicket('list')
                                }
                            }else if (inputJson.type != '' && inputJson.type == 'nominee') {
                                if (parameter.reason_for_create_ticket.address) {
                                    parameter.reason_for_create_ticket['bank'] = ''
                                    parameter.reason_for_create_ticket['cms'] = ''
                                    parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    let base_message = "Hi " + parameter.username + '<br>'
                                    base_message = base_message + " - During the back office document check, we found that your address proof document is missing. Kindly upload the address proof in this ticket to continue smooth trading." + ' <br>'
                                    let inputjson1 = {
                                        "reason": 19,
                                        "comment": base_message,
                                        "user_id": inputJson.user_id,
                                        "type": 'address',
                                        "rout": rout,
                                        "parameter": parameter
                                    }
                                    dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                }
                                // else if (parameter.reason_for_create_ticket.ipv) {
                                    // parameter.reason_for_create_ticket['bank'] = ''
                                    // parameter.reason_for_create_ticket['cms'] = ''
                                    // parameter.reason_for_create_ticket['cancel_cheque'] = ''
                                    // let base_message = "Hi " + parameter.username + '<br>'
                                    // base_message = base_message + " - As the IPV video you had made is not acceptable as per compliance, our customer support executive will be in touch with you regarding the same." + '<br>'
                                    // let inputjson1 = {
                                    //     "reason": 18,
                                    //     "comment": base_message,
                                    //     "user_id": inputJson.user_id,
                                    //     "type": 'ipv',
                                    //     "rout": rout,
                                    //     "parameter": parameter
                                    // }
                                    // dispatch(Const.RUN_STEP_SKIP_API, inputjson1);
                                // }
                                 else {
                                    parameter.createTicketModal = false
                                    parameter.reason_for_create_ticket['nominee'] = ''
                                    parameter.createTicket('list')
                                }
                            }else if (inputJson.type != '' && inputJson.type == 'hold_user') {
                                parameter.reason_for_create_ticket = { 'bank': '', 'cms': '', 'cancel_cheque': '', 'ipv': '', 'address': '', 'nominee' : '', 'hold_user' : ''}
                                parameter.createTicketModal = false
                                parameter.createTicket('list')
                            } else if (inputJson.type != '' && inputJson.type == 'list') {
                                parameter.ticket_data = data.data
                            }

                            //  parameter.$notify({
                            //     group: 'foo',
                            //     text: 'create ticket successfully',
                            //     type: 'success'
                            // });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_VIEW_ADMIN_USER_DETAIL]({ commit, state, getters }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            let checked = inputJson.checked
            delete inputJson.checked
            let checkedCash = inputJson.checkedCash
            delete inputJson.checkedCash
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_VIEW_ADMIN_USER_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (data.data.docs.length > 0) {
                                let j;
                                for (j = 0; j <= data.data.docs.length - 1; j++) {
                                    let getjsonData = _getImgeNameExntension(data.data.docs[j].document)
                                    data.data.docs[j].imgName = getjsonData.docName
                                    data.data.docs[j].extension = getjsonData.extension
                                }

                                if (j == data.data.docs.length) {
                                    localStorage.setItem("view_admin_detail", JSON.stringify(data.data));
                                    commit(Const.SET_VIEW_ADMIN_USER_DETAIL, data.data)
                                    if (parseInt(data.data.result[0].all_docs_verified) == 0) {
                                        parameter.checked = true
                                    }
                                    if (parseInt(data.data.result[0].open_cash) == 1) {
                                        parameter.checkedCash = true
                                    }
                                    rout.push({ path: '/view', query: { "Id": inputJson.id } })
                                    parameter.fetchPanData('')
                                }
                            } else {
                                localStorage.setItem("view_admin_detail", JSON.stringify(data.data));
                                commit(Const.SET_VIEW_ADMIN_USER_DETAIL, data.data)
                                if (parseInt(data.data.result[0].all_docs_verified) == 0) {
                                    parameter.checked = true
                                }
                                if (parseInt(data.data.result[0].open_cash) == 1) {
                                    parameter.checkedCash = true
                                }
                                rout.push({ path: '/view', query: { "Id": inputJson.id } })
                                parameter.fetchPanData('')
                            }

                        }
                        else {
                            commit(Const.SET_PAN_DATA, {})
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, {})
                            parameter.checked = checked
                            parameter.checkedCash = checkedCash
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CLIENT_INFO_EDIT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout

            const kra = inputJson.kra
            delete inputJson.kra

            const page = inputJson.page
            delete inputJson.page
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CLIENT_INFO_EDIT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                            let json;
                            if (page == 'search') {
                                json = getters[Const.GET_NEW_REGISTERATIONS]
                            } else {
                                json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            }

                            if (inputJson.type == 'EMAIL') {
                                json.result[0].user.email = inputJson.email
                                parameter.email_edit_show = false
                            } else if (inputJson.type == 'BASICINFO') {
                                json.result[0].user.pan_no = inputJson.pan_no
                                json.result[0].account_status = inputJson.account_status
                                json.result[0].user.client_code = inputJson.client_code
                                json.result[0].user.username = inputJson.username
                                json.result[0].husband_name = inputJson.husband_name
                                json.result[0].mother_name = inputJson.mother_name
                                json.result[0].maiden_name = inputJson.maiden_name
                                json.result[0].dob = inputJson.dob
                                json.result[0].gross_income = inputJson.gross_income
                                json.result[0].occupation = inputJson.occupation
                                json.result[0].occupation_other = inputJson.occupation_other
                                json.result[0].pep = inputJson.pep
                                json.result[0].gender = inputJson.gender
                                json.result[0].payment_method = inputJson.payment_method
                                json.result[0].ipv_status = inputJson.ipv_status
                                json.result[0].martial_status = inputJson.marital_status
                                json.result[0].residential_status = inputJson.residential_status
                                json.result[0].kradetail_verified = inputJson.kradetail_verified
                                if (kra == 1) {
                                    parameter.client_info_edit_show_kra1 = false
                                } else {
                                    parameter.client_info_edit_show = false
                                }
                            } else if (inputJson.type == 'ADDRESS') {
                                json.result[0].address1 = inputJson.address1
                                json.result[0].address2 = inputJson.address2
                                json.result[0].address3 = inputJson.address3
                                json.result[0].city = inputJson.city
                                json.result[0].state = inputJson.state
                                json.result[0].pincode = inputJson.pincode
                                json.result[0].country = inputJson.country
                                json.result[0].address_proof = inputJson.address_proof
                                json.result[0].address_type = inputJson.address_type
                                parameter.address_edit_show = false

                                json.result[0].corr_address1 = inputJson.corr_address1
                                json.result[0].corr_address2 = inputJson.corr_address2
                                json.result[0].corr_address3 = inputJson.corr_address3
                                json.result[0].corr_city = inputJson.corr_city
                                json.result[0].corr_state = inputJson.corr_state
                                json.result[0].corr_pincode = inputJson.corr_pincode
                                json.result[0].corr_country = inputJson.corr_country
                                json.result[0].corr_address_proof = inputJson.corr_address_proof
                            } else if (inputJson.type == 'BANK') {
                                json.result[0].bank_name = inputJson.bank_name
                                json.result[0].bank_address = inputJson.bank_address
                                json.result[0].bank_account_no = inputJson.bank_account_no
                                json.result[0].bank_accounttype = inputJson.bank_accounttype
                                json.result[0].bank_ifsc = inputJson.bank_ifsc
                                json.result[0].bank_micrcode = inputJson.bank_micrcode
                                json.result[0].bank_name_other = inputJson.bank_name_other
                                parameter.bank_edit_show = false
                            } else if (inputJson.type == 'FATCAINFO') {
                                json.result[0].fatca_birthplace = inputJson.fatca_birthplace
                                json.result[0].fatca_country = inputJson.fatca_country
                                json.result[0].fatca_country_birth = inputJson.fatca_country_birth
                                json.result[0].fatca_tax_id = inputJson.fatca_tax_id
                                parameter.fatca_info_edit_show = false
                            } else if (inputJson.type == 'DEMATINFO') {
                                json.result[0].name_depository = inputJson.name_depository
                                json.result[0].dp_id = inputJson.dp_id
                                json.result[0].benificiary_bo_id = inputJson.benificiary_bo_id
                                json.result[0].benificiary_name = inputJson.benificiary_name
                                json.result[0].participant_name = inputJson.participant_name
                                parameter.demat_info_edit_show = false
                            } else if (inputJson.type == 'PLATFORMINFO') {
                                json.result[0].NSE_CASH = inputJson.NSE_CASH
                                json.result[0].BSE_CASH = inputJson.BSE_CASH
                                json.result[0].NSE_FO = inputJson.NSE_FO
                                json.result[0].BSE_FO = inputJson.BSE_FO
                                json.result[0].MCX = inputJson.MCX
                                json.result[0].NCDEX = inputJson.NCDEX
                                json.result[0].NSE_CUR = inputJson.NSE_CUR
                                json.result[0].BSE_CUR = inputJson.BSE_CUR
                                json.result[0].NSE_COMM = inputJson.NSE_COMM
                                parameter.platform_info_edit_show = false
                            }


                            if (page == 'search') {
                                localStorage.setItem("new_registerations", JSON.stringify(json));
                                commit(Const.SET_NEW_REGISTERATIONS, json)
                                parameter.client_info_edit_show = false
                            } else {
                                localStorage.setItem("view_admin_detail", JSON.stringify(json));
                                commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                            }

                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_FETCH_KRA_KYC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_FETCH_KRA_KYC, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let json = getters[Const.GET_USER_DOCUMENT_URL]
                            let file_path = json + '&id=' + inputJson.user_id + '&doc=' + data.data + '&kradoc=1'
                            window.open(file_path, '_blank');

                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_LIST_USER_RISING_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data; let API
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            if ('from_kra' in data) {
                API = Enpoints.EP_LIST_USER_RISING_SYNC_NON_KRA
            } else {
                API = Enpoints.EP_LIST_USER_RISING_SYNC
            }
            console.log(API, "----------------", inputJson)
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + API, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.array_verify_sign = []
                            if ('from_kra' in inputJson) {
                                let xml_doc_url = getters[Const.GET_XML_DOC_URL]
                                let file_path = xml_doc_url + data.data.xmlData
                                window.open(file_path, '_blank');
                                for (var i = 0; i <= data.data.csvData.length - 1; i++) {
                                    //data.data.csvData[i]['NOMINEEFLAG'] = (parseInt(data.data.csvData[i]['nominee']) == 0) ? '2' : '1'
                                    // console.log('==========',data.data.csvData[i])
                                    if (data.data.csvData[i].bank_name != undefined && data.data.csvData[i].bank_name.toLowerCase() == 'others') {
                                        data.data.csvData[i].bank_name = data.data.csvData[i].bank_name_other
                                    }
                                    delete data.data.csvData[i].bank_name_other
                                    if (i == data.data.csvData.length - 1) {
                                        console.log('final11==========', data.data.csvData)
                                        parameter.csvExport(data.data.csvData)
                                    }
                                }
                                for (var i = 0; i <= data.data.csvData.length - 1; i++) {
                                    //console.log(data.data.csvData[i],'=====non=====',getters[Const.GET_KS_COUNTRY_LIST][data.data[i].app_per_ctry])
                                    // if(data.data.csvData[i].bank_name != undefined && data.data.csvData[i].bank_name.toLowerCase() == 'others'){
                                    //     data.data.csvData[i].bank_name = data.data.csvData[i].bank_name_other
                                    // }
                                    if (getters[Const.GET_KS_COUNTRY_LIST][data.data.csvData[i].app_cor_ctry] != undefined) {
                                        data.data.csvData[i].app_cor_ctry = getters[Const.GET_KS_COUNTRY_LIST][data.data.csvData[i].app_cor_ctry]
                                    }
                                    if (getters[Const.GET_KS_STATE_LIST][data.data.csvData[i].app_cor_state] != undefined) {
                                        data.data.csvData[i].app_cor_state = getters[Const.GET_KS_STATE_LIST][data.data.csvData[i].app_cor_state]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_PROOF_LIST][data.data.csvData[i].app_cor_add_proof] != undefined) {
                                        data.data.csvData[i].app_cor_add_proof = getters[Const.GET_KS_ADDRESS_PROOF_LIST][data.data.csvData[i].app_cor_add_proof]
                                    }
                                    if (getters[Const.GET_KS_COUNTRY_LIST][data.data.csvData[i].app_per_ctry] != undefined) {
                                        data.data.csvData[i].app_per_ctry = getters[Const.GET_KS_COUNTRY_LIST][data.data.csvData[i].app_per_ctry]
                                    }
                                    if (getters[Const.GET_KS_STATE_LIST][data.data.csvData[i].app_per_state] != undefined) {
                                        data.data.csvData[i].app_per_state = getters[Const.GET_KS_STATE_LIST][data.data.csvData[i].app_per_state]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_PROOF_LIST][data.data.csvData[i].app_per_add_proof] != undefined) {
                                        data.data.csvData[i].app_per_add_proof = getters[Const.GET_KS_ADDRESS_PROOF_LIST][data.data.csvData[i].app_per_add_proof]
                                    }
                                    if (getters[Const.GET_KS_MATRIAL_DATA][data.data.csvData[i].app_mar_status] != undefined) {
                                        data.data.csvData[i].app_mar_status = getters[Const.GET_KS_MATRIAL_DATA][data.data.csvData[i].app_mar_status]
                                    }
                                    if (getters[Const.GET_KS_OCCUPATION_LIST][data.data.csvData[i].app_occ] != undefined) {
                                        data.data.csvData[i].app_occ = getters[Const.GET_KS_OCCUPATION_LIST][data.data.csvData[i].app_occ]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_TYPE_LIST][data.data.csvData[i].app_res_status] != undefined) {
                                        data.data.csvData[i].app_res_status = getters[Const.GET_KS_ADDRESS_TYPE_LIST][data.data.csvData[i].app_res_status]
                                    }
                                    if (i == data.data.csvData.length - 1) {
                                        //console.log('final11==========',data.data.csvData)
                                        parameter.ksCsvExport(data.data.csvData)
                                    }
                                }
                            } else {
                                console.log(data.data)
                                let risingFileArray = [] , ksFileArray = [];
                                risingFileArray = data.data
                                ksFileArray = data.data
                                for (var i = 0; i <= risingFileArray.length - 1; i++) {
                                    risingFileArray[i]['NOMINEEFLAG'] = (parseInt(risingFileArray[i]['NOMINEEFLAG']) == 0) ? '2' : '1'
                                    if (risingFileArray[i].bank_name != undefined && risingFileArray[i].bank_name.toLowerCase() == 'others') {
                                        risingFileArray[i].bank_name = risingFileArray[i].bank_name_other
                                    }
                                    delete risingFileArray[i].bank_name_other
                                    if (i == risingFileArray.length - 1) {
                                        console.log('risingFileArray==========', risingFileArray)
                                        parameter.csvExport(risingFileArray)
                                    }
                                }
                                for (var i = 0; i <= ksFileArray.length - 1; i++) {
                                    if (getters[Const.GET_KS_COUNTRY_LIST][ksFileArray[i].app_cor_ctry] != undefined) {
                                        ksFileArray[i].app_cor_ctry = getters[Const.GET_KS_COUNTRY_LIST][ksFileArray[i].app_cor_ctry]
                                    }
                                    if (getters[Const.GET_KS_STATE_LIST][ksFileArray[i].app_cor_state] != undefined) {
                                        ksFileArray[i].app_cor_state = getters[Const.GET_KS_STATE_LIST][ksFileArray[i].app_cor_state]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_PROOF_LIST][ksFileArray[i].app_cor_add_proof] != undefined) {
                                        ksFileArray[i].app_cor_add_proof = getters[Const.GET_KS_ADDRESS_PROOF_LIST][ksFileArray[i].app_cor_add_proof]
                                    }
                                    if (getters[Const.GET_KS_COUNTRY_LIST][ksFileArray[i].app_per_ctry] != undefined) {
                                        ksFileArray[i].app_per_ctry = getters[Const.GET_KS_COUNTRY_LIST][ksFileArray[i].app_per_ctry]
                                    }
                                    if (getters[Const.GET_KS_STATE_LIST][ksFileArray[i].app_per_state] != undefined) {
                                        ksFileArray[i].app_per_state = getters[Const.GET_KS_STATE_LIST][ksFileArray[i].app_per_state]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_PROOF_LIST][ksFileArray[i].app_per_add_proof] != undefined) {
                                        ksFileArray[i].app_per_add_proof = getters[Const.GET_KS_ADDRESS_PROOF_LIST][ksFileArray[i].app_per_add_proof]
                                    }
                                    if (getters[Const.GET_KS_MATRIAL_DATA][ksFileArray[i].app_mar_status] != undefined) {
                                        ksFileArray[i].app_mar_status = getters[Const.GET_KS_MATRIAL_DATA][ksFileArray[i].app_mar_status]
                                    }
                                    if (getters[Const.GET_KS_OCCUPATION_LIST][ksFileArray[i].app_occ] != undefined) {
                                        ksFileArray[i].app_occ = getters[Const.GET_KS_OCCUPATION_LIST][ksFileArray[i].app_occ]
                                    }
                                    if (getters[Const.GET_KS_ADDRESS_TYPE_LIST][ksFileArray[i].app_res_status] != undefined) {
                                        ksFileArray[i].app_res_status = getters[Const.GET_KS_ADDRESS_TYPE_LIST][ksFileArray[i].app_res_status]
                                    }
                                    if (i == ksFileArray.length - 1) {
                                        console.log("ksFileArray======",ksFileArray)
                                        parameter.ksCsvExport(ksFileArray)
                                    }
                                }
                            }
                            
                            parameter.listing('1', '', parameter.Userparameter)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_PAN_API]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_PAN_API, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            for (var i = 0; i <= json.docs.length - 1; i++) {
                                if (json.docs[i].docsId == inputJson.id) {
                                    json.docs[i].is_pan = inputJson.is_pan
                                }
                            }
                            if (i == json.docs.length) {
                                localStorage.setItem("view_admin_detail", JSON.stringify(json));
                                commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                                parameter.$notify({
                                    group: 'foo',
                                    text: data.msg,
                                    type: 'success'
                                });
                            }

                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_USER_VERIFY_FINAL]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_USER_VERIFY_FINAL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.doc_array = []
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        } else {
                            parameter.doc_array = []
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RESIGN_USER_KYC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            const id = inputJson.id
            delete inputJson.id

            parameter.$parent.pageLoader = true

            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RESIGN_USER_KYC, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        parameter.doc_kyc_array = []
                        if (data.info === 'OK') {
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            for (var key in json.docs) {
                                if (json.docs[key].docsId == inputJson.docs[0].id) {

                                    json.docs[key].status = 1
                                }
                            }
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                            parameter.resign_kyc_button = false
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_ACCEPT_REJECT_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            const imgname = data.docs[0].document
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_ACCEPT_REJECT_DOCUMENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            for (var key in json.docs) {
                                if (json.docs[key].document == imgname) {

                                    json.docs[key].status = inputJson.flag
                                }
                            }
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_ACCEPT_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_ACCEPT_USER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.accept_hold_field = '0'
                            parameter.$notify({
                                group: 'foo',
                                text: "Accept user successfully !",
                                type: 'success'
                            });
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            json.result[0].list_step = 7
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_HOLD_USER]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_HOLD_USER, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.accept_hold_field = '0'
                            parameter.$notify({
                                group: 'foo',
                                text: "Reject user successfully !",
                                type: 'success'
                            });
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            json.result[0].hold_reason = parameter.hold_reason
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ACCEPT_USER_KYC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ACCEPT_USER_KYC, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "Accept User Kyc Successfully!",
                                type: 'success'
                            });
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            json.result[0].list_step = 10
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                        }
                        else {
                            parameter.showModal = true
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ENABLE_ESIGN_DOC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;

            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ENABLE_ESIGN_DOC, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "Enable Esign Successfully!",
                                type: 'success'
                            });
                            let json = getters[Const.GET_VIEW_ADMIN_USER_DETAIL]
                            json.result[0].entered_manually = 0
                            localStorage.setItem("view_admin_detail", JSON.stringify(json));
                            commit(Const.SET_VIEW_ADMIN_USER_DETAIL, json)
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_OPEN_CASH]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;

            delete inputJson.parameter;
            delete inputJson.rout

            const checkedCash = inputJson.checkedCash;
            delete inputJson.checkedCash;
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_OPEN_CASH, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "open cash Successfully!",
                                type: 'success'
                            });
                            parameter.viewUserDetail(inputJson.user_id)
                        } else {
                            parameter.checkedCash = !checkedCash
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ACCEPT_USER_KYC_MANUALLY]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ACCEPT_USER_KYC_MANUALLY, data.form, { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$parent.showModal = false
                            parameter.$parent.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$parent.showModal = true
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CHANGE_USER_STEP]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CHANGE_USER_STEP, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if(parameter.stepInformation == "-3") {
                                parameter.disableOption = true
                            }
                            
                            parameter.stepInformation = ''
                            parameter.reject_reason = ''
                            parameter.reject_reason_flag = false
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //=====================================dashboard api======================================
    [Const.RUN_LOCK_UNLOCK_TRANSACTION]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_LOCK_UNLOCK_TRANSACTION, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            dispatch(Const.RUN_GET_LOCK_UNLOCK_DATA, { "rout": rout, "parameter": parameter });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_GET_LOCK_UNLOCK_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_LOCK_UNLOCK_DATA, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            commit(Const.SET_LOCK_UNLOCK_DATA, data.data)
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DASHBOARD_API]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            //parameter.$parent.pageLoader= true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DASHBOARD_API, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => { //parameter.$parent.pageLoader= false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            commit(Const.SET_DASHBOARD_DATA, data.data)
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_UPLOAD_PAYOUT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_PAYOUT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
     [Const.RUN_UPLOAD_ACCOUNT_PAYOUT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_ACCOUNT_PAYOUT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_UPLOAD_ACCOUNT_STATUS_DOC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_ACCOUNT_STATUS_DOC, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_UPLOAD_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_DOCUMENT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    parameter.$refs.doc.value = ''
                    parameter.reset()
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }

                    }

                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_UPLOAD_CVL_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_CVL_DOCUMENT, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader = false
                    parameter.$refs.doc.value = ''
                    parameter.reset()
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            window.open(Enpoints.BASE_URL+'/'+data.data, '_blank');
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }

                    }

                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_UPLOAD_ATOM_TRNS_FILE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_ATOM_TXN_PAYIN, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },


    [Const.RUN_UPLOAD_MF_ISIN_DOC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_UPLOAD_MF_ISIN_DOC, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_MARGIN_PLEDGE_ISIN_DOC]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MARGIN_PLEDGE_ISIN_DOC, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_GET_BANK_DETAIL_SHEET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_BANK_DETAIL_SHEET, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CREDITED_BY_ATOM]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ATOM_CREDIT_PAYMENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.listing('1')
                            parameter.array_payment = []
                            parameter.atom_array = []
                            parameter.ignore_array = []
                            parameter.bnk_array = []
                            parameter.$notify({
                                group: 'foo',
                                text: "upload document successfully",
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_GET_LIST_USER_SYNCED]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_LIST_USER_SYNCED, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let i;
                            for (i = 0; i <= data.data.length - 1; i++) {
                                delete data.data[i].prifile
                            }

                            if (i == data.data.length) {
                                parameter.csvExport(data.data, 'user-data.csv')
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_PAYOUT_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_PAYOUT_LIST, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let i; let array_payout = []; let json_payout = {}
                            for (i = 0; i <= data.data.length - 1; i++) {
                                if (data.data[i].bank_name != '' && data.data[i].bank_name != null && data.data[i].bank_name.toLowerCase() == 'others') {
                                    data.data[i].bank_name = ((data.data[i].bank_name_other != '' && data.data[i].bank_name_other != null) ? data.data[i].bank_name_other.trim() : '');
                                } else {
                                    data.data[i].bank_name = ((data.data[i].bank_name != '' && data.data[i].bank_name != null) ? data.data[i].bank_name.trim() : '');
                                }

                                json_payout = {}
                                json_payout['Tansaction Type'] = 'N'
                                json_payout['Beneficiay Code'] = ''
                                json_payout['Beneficiay Account Numbe'] = "'" + data.data[i].bank_account_no.trim()
                                json_payout['Instument Amount'] = data.data[i].amount.trim()
                                json_payout['Beneficiay Name'] = data.data[i].benificiary_name.trim()
                                json_payout['Dawee Location'] = ''
                                json_payout['Pint Location'] = ''
                                json_payout['Bene Addess 1'] = ''
                                json_payout['Bene Addess 2'] = ''
                                json_payout['Bene Addess 3'] = ''
                                json_payout['Bene Addess 4'] = ''
                                json_payout['Bene Addess 5'] = ''
                                json_payout['Instuction efeence Numbe'] = ''
                                json_payout['Custome efeence Numbe'] = data.data[i].comment.trim()
                                json_payout['Payment details 1'] = ''
                                json_payout['Payment details 2'] = ''
                                json_payout['Payment details 3'] = ''
                                json_payout['Payment details 4'] = ''
                                json_payout['Payment details 5'] = ''
                                json_payout['Payment details 6'] = ''
                                json_payout['Payment details 7'] = ''
                                json_payout['Cheque Numbe'] = ''
                                json_payout['Chq / Tn Date(DD/MM/YYYY)'] = moment().format('DD/MM/YYYY').trim()
                                json_payout['MIC Numbe'] = ''
                                json_payout['IFSC Code'] = data.data[i].bank_ifsc.toUpperCase().trim()
                                json_payout['Bene Bank Name'] = data.data[i].bank_name
                                json_payout['Bene Bank Banch Name'] = ''
                                json_payout['Beneficiay email id'] = '"' + data.data[i].email.trim() + ',accounts@finvasia.in"'
                                array_payout.push(json_payout)
                                if (i == data.data.length - 1) {
                                    parameter.csvExport(array_payout, 'payout-list ' + moment().format('DD-MM-YYYY hh:mm') + '.csv')
                                }
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },



    [Const.RUN_MISSING_PIC_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            const ticket_id = inputJson.ticketId;
            const ticket_list_data = inputJson.ticket_list_data
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_MISSING_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": ticket_id, "rout": rout, "parameter": parameter });
                            parameter.$notify({
                                group: 'foo',
                                text: "Pic Uploaded Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },


    [Const.RUN_GET_RISING_UPDATE_SYNCED]({ commit, state, getters, dispatch }, data) {
        try {
            let json_array_rising_data = []
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_RISING_UPDATE_SYNCED, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let i;
                            for (i = 0; i <= data.data.length - 1; i++) {
                                let json_fields = {
                                    'client_code': '', 'type': '', 'phone': '', 'email': '', 'amount': '', 'gst': '', 'gst_amount': '', 'platform': '', 'total_amount': '', 'nse-cash': '', 'nse-fo': '', 'nse-currency': '', 'bse-cash': '', 'bse-fo': '', 'bse-currency': '', 'mcx-fo': '', 'bank_name': '', 'address': '', 'account_no': '', 'ifsc': '', 'mirc': '', 'address_change': '', 'address_proof': '', 'address_type': '', 'doc_code': '', 'new_address1': '', 'new_address2': '', 'new_address3': '', 'new_city': '', 'new_country': '', 'new_pincode': '', 'new_state': '', 'others': '', 'last_trade_date': '', 'created': ''
                                };
                                json_fields.type = 'Change ' + data.data[i].type
                                json_fields.client_code = data.data[i].client_code
                                json_fields.created = moment(data.data[i].created).format('DD-MM-YYYY hh:mm')
                                let count = 0
                                for (var key in data.data[i].detail) {
                                    count++
                                    if ((data.data[i].type == 'platform' || data.data[i].type == 'segment' || data.data[i].type == 'reactivation') && (key == 'nse' || key == 'bse' || key == 'mcx')) {
                                        for (var innerkey in data.data[i].detail[key]) {
                                            json_fields[key + '-' + innerkey] = data.data[i].detail[key][innerkey]
                                        }
                                    } else {
                                        json_fields[key] = data.data[i].detail[key]
                                    }
                                }
                                if (count == Object.keys(data.data[i].detail).length) {
                                    json_array_rising_data.push(json_fields)
                                }
                            }

                            if (i == data.data.length) {
                                parameter.csvExport(json_array_rising_data, 'user-rising-data.csv')
                            }
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //=====================================tickets api========================================
    [Const.RUN_ADMIN_ASSIGN_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_ASSIGN_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info == 'OK') {
                            rout.replace('/Tickets/support')
                            parameter.$notify({
                                group: 'foo',
                                text: "Assign Ticket Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_REJECT_USER_DOCS]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_REJECT_USER_DOCS, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$notify({
                                group: 'foo',
                                text: 'user ticket reject successfully',
                                type: 'success'
                            });
                            parameter.viewTicket(inputJson.id)
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DISABLE_SEGMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout;
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_DISABLE_SEGMENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.viewTicket(inputJson.id)
                            parameter.$notify({
                                group: 'foo',
                                text: "Segment Disabled Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_RESIGN_DOCUMENT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data

            parameter.$parent.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_RESIGN_DOCUMENT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": inputJson.ticket_id, "rout": rout, "parameter": parameter });
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADD_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            var inputJson = data
            const parameter = inputJson.parameter
            const rout = inputJson.rout
            const modules = inputJson.request_type
            const flag = inputJson.flag
            const id = inputJson.id
            delete inputJson.parameter
            delete inputJson.rout
            delete inputJson.flag
            delete inputJson.id
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_REPLY_SUPPORT_DATA, data.form, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            if (flag == "cancel_ticket") {
                                parameter.msz_Box = false
                            } else if (flag == "internalCommentTicket") {
                                parameter.inter_comment_show = false
                            }
                            parameter.reset()
                            dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": id, "rout": rout, "parameter": parameter });
                        } else {
                            if (flag == "cancel_ticket") {
                                parameter.msz_Box = false
                            } else if (flag == "internalCommentTicket") {
                                parameter.inter_comment_show = false
                            }
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_GET_LISTING_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter
            const rout = inputJson.rout
            const pageName = inputJson.page_name
            const mutation_variable = inputJson.mutation_variable
            delete inputJson.parameter
            delete inputJson.rout
            delete inputJson.mutation_variable
            delete inputJson.page_name
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data
            parameter.pageLoader1 = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_SUPPORT_LISTING, inputJson, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.pageLoader1 = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            commit(Const[mutation_variable], data.data)
                            if (mutation_variable == "SET_SUPPORT_LIST") {
                                localStorage.setItem("filter", JSON.stringify(ticket_list_data));
                                //rout.replace(pageName)
                            }
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) }
                )
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_SPLITTER_LIST]({ commit, state, getters, dispatch }, data) {
        const apiUrl = Enpoints.BASE_URL + Enpoints.EP_SPLITTER_LIST;
        const headers = { 'Authorization': 'Bearer ' + getters.GET_TOKEN };
      
        return axios.post(apiUrl, data, { headers })
          .then((response) => {
            console.log(response)
            const responseData = response.data;
            if ('info' in responseData && responseData.info === 'OK') {
                console.log(responseData.data)
              commit(Const.SET_SPLITTER_LIST, { payload: responseData.data });
            }
          })
          .catch((error) => {
            _handleErrorResponse(error, commit);
            Vue.notify({
              group: 'foo',
              text: strictValidString(error.msg) ? error.msg : 'something went wrong!',
              type: 'error'
            });
          });
    },
    [Const.RUN_SPLITTER_CANCEL]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SPLITTER_CANCEL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$parent.$parent.$notify({
                                group: 'foo',
                                text: 'File uploading cancelled',
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_SPLITTER_DELETE]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_SPLITTER_DELETE, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.$parent.$parent.$notify({
                                group: 'foo',
                                text: 'File Deleted Successfully',
                                type: 'success'
                            });
                            parameter.fetchData()
                        }
                        else {
                            parameter.fetchData()
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DONWLOAD_CONSENT_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const filterDataForCSV = (records = []) => {
                let tempList = [];
                records.map((val, count) => {
                    tempList.push({
                        ID: val.id || '',
                        ClientCode: val.client_code || '',
						PAN: val.pan_no,
                        Esign_name: val.esign_name || '',
                        Prism_Name: val.prism_name || '',

                    })
                })
                let csvContent = "data:text/csv;charset=utf-8,";
				csvContent += [
				Object.keys(tempList[0]).join(","),
				...tempList.map(item => Object.values(item).join(","))
				]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");
				const data = encodeURI(csvContent);
				const link = document.createElement("a");
				link.setAttribute("href", data);
				link.setAttribute("download", `consent-list.csv`);
				link.click();
            }
            RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_DOWNLOAD_CONSENT, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            console.log(data)
                            filterDataForCSV(data.data)
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) }
                )
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_DOWNLOAD_ASBA_DATA]({ commit, state, getters, dispatch }, data) {
        try {
            const filterDataForCSV = (records = []) => {
                let tempList = [];
                records.map((val, count) => {
                    tempList.push({
                        'Client Code': val.client_code || '',
                        'Ticket Type' : val.request_type || '',
                        'Comment' : val.comment || '',
                        'TM Code' : val.time_code || '',
                        'ASBA-UPI' : val.asba_UPI || '',
                        'Segment' : val.segment || '',
                        'Bank Account Number 1' : val.bank_account_number1 || '',
                        'Bank Account Number 2' : val.bank_account_number2 || '',
                        'Bank Account Number 3' : val.bank_account_number3 || '',
                        'IFSC BANK 1' : val.ifsc_bank1 || '',
                        'IFSC BANK 2' : val.ifsc_bank2 || '',
                        'IFSC BANK 3' : val.ifsc_bank3 || '',

                    })
                })
                let csvContent = "data:text/csv;charset=utf-8,";
				csvContent += [
				Object.keys(tempList[0]).join(","),
				...tempList.map(item => Object.values(item).join(","))
				]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");
				const data = encodeURI(csvContent);
                const formattedDateTime = moment().format("DD-MM-YYYY-hh:mmA");
				const link = document.createElement("a");
				link.setAttribute("href", data);
				link.setAttribute("download", `asba-report-${formattedDateTime}.csv`);
				link.click();
            }
            RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_DOWNLOAD_ASBA, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            console.log(data)
                            filterDataForCSV(data.data)
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) }
                )
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_VIEW_SUPPORT_DETAIL]({ commit, state, getters }, data) {
        try {
            commit(Const.SET_SUPPORT_VIEW, {})
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data
            //parameter.pageLoader_view_support_detail = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_VIEW_SUPPORT_DETAIL, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {   //parameter.pageLoader_view_support_detail = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            data.data.ticket_list_data = ticket_list_data
                            let count = 0; let count1 = 0; let i = 0; let j = 0; let k = 0; let doc_array = []
                            if ((typeof data.data.threads !== 'undefined') && (data.data.threads.length > 0)) {
                                for (var threadkey = 0; threadkey < data.data.threads.length; threadkey++) {
                                    if (data.data.threads[threadkey].docs.length > 0) {
                                        for (var dockey = 0; dockey < data.data.threads[threadkey].docs.length; dockey++) {
                                            doc_array.push(data.data.threads[threadkey].docs[dockey])
                                            count1++
                                            if (parseInt(data.data.threads[threadkey].docs[dockey].status) == 0) {
                                                i = 1
                                            } else {
                                                if(parseInt(data.data.threads[threadkey].docs[dockey].status) == 1){
                                                    k = 1
                                                }
                                                j = 1
                                            }
                                            if (data.data.threads[threadkey].docs.length - 1 == dockey) {
                                                count++
                                            }
                                        }
                                    } else {
                                        count++
                                    }
                                    if (data.data.threads.length - 1 == threadkey) {
                                        if (k == 1) {  data.data.rejected_doc = true;  }else{ data.data.rejected_doc = false;  }


                                        if (i == 1) {
                                            data.data.approve_signFinally = false;
                                        } else {
                                            data.data.approve_signFinally = true;
                                        }
                                        // data.data.doc_array = doc_array
                                        localStorage.setItem("Support", JSON.stringify(data.data));
                                        console.log(data.data)
                                        commit(Const.SET_SUPPORT_DOCS, doc_array)
                                        commit(Const.SET_SUPPORT_VIEW, data.data)
                                    }
                                }
                            } else {
                                data.data.approve_signFinally = true

                                localStorage.setItem("Support", JSON.stringify(data.data));
                                commit(Const.SET_SUPPORT_VIEW, data.data)
                            }
                            rout.push({ name: 'Tickets.TicketView', query: { "Id": inputJson.id } })
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_GET_SUPPORT_REASON_LIST]({ commit, state, getters, dispatch }, data) {
        try {
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_GET_SUPPORT_REASON_LISTING, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            commit(Const.SET_SUPPORT_REASON_LIST, data.data)
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_APPROVE_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            const ticketId = inputJson.ticketId;
            delete inputJson.ticketId;
            delete inputJson.parameter;
            delete inputJson.rout;
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_APPROVE_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let support_view_data = getters[Const.GET_SUPPORT_VIEW]
                            support_view_data.ticket[0].admin_approved = 1
                            support_view_data.approve_signFinally = true
                            localStorage.setItem("Support", JSON.stringify(support_view_data));
                            commit(Const.SET_SUPPORT_VIEW, support_view_data)
                            parameter.viewTicket(ticketId)
                            parameter.$notify({
                                group: 'foo',
                                text: "Ticket Approved Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_APPROVE_TICKET_STEP2]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout;
            const ticketId = inputJson.ticketId
            delete inputJson.ticketId;
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_APPROVE_TICKET_STEP2, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let support_view_data = getters[Const.GET_SUPPORT_VIEW]
                            // support_view_data.ticket[0].admin_approved = 2
                            support_view_data.approve_signFinally = true
                            localStorage.setItem("Support", JSON.stringify(support_view_data));
                            commit(Const.SET_SUPPORT_VIEW, support_view_data)
                            parameter.viewTicket(ticketId)
                            parameter.$notify({
                                group: 'foo',
                                text: "Ticket Approved Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_APPROVE_HV_REACTIVATION_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout;
            const ticketId = inputJson.ticketId
            delete inputJson.ticketId;
            parameter.$parent.pageLoader = true
            RxFactory.post(process.env.HV_BASE_URL + Enpoints.EP_ADMIN_APPROVE_HV_REACTIVATION_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            console.log(data)
                            // let support_view_data = getters[Const.GET_SUPPORT_VIEW]
                            // // support_view_data.ticket[0].admin_approved = 2
                            // support_view_data.approve_signFinally = true
                            // localStorage.setItem("Support", JSON.stringify(support_view_data));
                            // commit(Const.SET_SUPPORT_VIEW, support_view_data)
                            // parameter.viewTicket(ticketId)
                            parameter.$notify({
                                group: 'foo',
                                text: "Ticket Approved Successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_PUSH_TO_KORP_HV_REACTIVATION_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout;
            const ticketId = inputJson.ticketId
            delete inputJson.ticketId;
            parameter.$parent.pageLoader = true
            // RxFactory.post(process.env.HV_BASE_URL + Enpoints.EP_ADMIN_PUSH_TO_KORP_HV_REACTIVATION_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
            RxFactory.post('https://betaprism-api.shoonya.com' + Enpoints.EP_ADMIN_PUSH_TO_KORP_HV_REACTIVATION_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            console.log(data)
                            parameter.$notify({
                                group: 'foo',
                                text: "Data pushed to KORP successfully",
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    // RUN_ADMIN_PUSH_TO_KORP_HV_REACTIVATION_TICKET
    [Const.RUN_ADMIN_ACCEPT_REJECT_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            const ticket_id = inputJson.ticket_id;
            const flag = inputJson.flag;
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data
            parameter.$parent.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_ACCEPT_REJECT_TICKET, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.$parent.pageLoader = false
                    if ('info' in data) {
                        parameter.doc_check = []
                        if (data.info === 'OK') {
                            dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": ticket_id, "rout": rout, "parameter": parameter });
                            parameter.accept_reject_button = false
                            if (flag == 1) {
                                parameter.rejection_message = false
                            }

                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },

    [Const.RUN_ADMIN_COMPRESS_PDF]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout

            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data

            const ticket_id = inputJson.ticket_id
            delete inputJson.ticket_id
           
            parameter.$parent.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_COMPRESS_PDF, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.$parent.pageLoader = false
                    if ('info' in data) {
                        parameter.doc_check = []
                        if (data.info === 'OK') {
                            if(ticket_id != ''){
                                dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": ticket_id, "rout": rout, "parameter": parameter });
                            }else{
                                parameter.viewUserDetail(inputJson.user_id)
                            }
                            
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_TICKET_STATUS_FUNCTION]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            const page = inputJson.page;
            delete inputJson.page;
            const ticket_list_data = inputJson.ticket_list_data;
            delete inputJson.ticket_list_data;
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_TICKET_STATUS_FUNCTION, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            let msz; let admin_approved;
                            if (page == 'support_list') {
                                if (inputJson.status == '1') {
                                    msz = "reopen ticket successfully"
                                    admin_approved = 1
                                } else {
                                    msz = "close ticket successfully"
                                    admin_approved = 0
                                }
                                dispatch(Const.RUN_GET_LISTING_DATA, { "status": 0, "page": 1, "admin_approved": admin_approved, "page_name": '/Tickets/support', "rout": rout, "parameter": parameter, "mutation_variable": "SET_SUPPORT_LIST" });
                            } else {
                                if (inputJson.status == '1') {
                                    msz = "reopen ticket successfully"
                                } else {
                                    msz = "close ticket successfully"
                                }
                                dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": inputJson.ticket_id, "rout": rout, "parameter": parameter });
                            }

                            parameter.$notify({
                                group: 'foo',
                                text: msz,
                                type: 'success'
                            });
                        }
                        else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_CANCEL_TICKET]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const parameter = inputJson.parameter;
            const rout = inputJson.rout;
            delete inputJson.parameter;
            delete inputJson.rout
            const ticket_list_data = inputJson.ticket_list_data
            delete inputJson.ticket_list_data
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_TICKET_STATUS_FUNCTION, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.msz_Box = false
                            parameter.$parent.$parent.listing_component = true
                            dispatch(Const.RUN_VIEW_SUPPORT_DETAIL, { "ticket_list_data": ticket_list_data, "id": inputJson.ticket_id, "rout": rout, "parameter": parameter });
                            parameter.$parent.$parent.$notify({
                                group: 'foo',
                                text: 'cancel ticket successfully',
                                type: 'success'
                            });
                        }
                        else {
                            parameter.msz_Box = false
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    //=======================================funds api==========================================
    [Const.RUN_CANCEL_PAYOUT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_CANCEL_PAYOUT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.reset()
                            parameter.$notify({
                                group: 'foo',
                                text: 'reject payout successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_PAYIN]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_PAYIN, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.reset()
                            parameter.$notify({
                                group: 'foo',
                                text: 'user payin successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    },
    [Const.RUN_ADMIN_PAYOUT]({ commit, state, getters, dispatch }, data) {
        try {
            const inputJson = data
            const rout = inputJson.rout
            const parameter = inputJson.parameter
            delete inputJson.parameter
            delete inputJson.rout
            parameter.$parent.pageLoader = true
            RxFactory.post(Enpoints.BASE_URL + Enpoints.EP_ADMIN_PAYOUT, data, { 'Authorization': 'Bearer ' + getters.GET_TOKEN })
                .map(response => response.data)
                .subscribe(data => {
                    parameter.$parent.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            parameter.reset()
                            parameter.$notify({
                                group: 'foo',
                                text: 'user payout successfully',
                                type: 'success'
                            });
                        } else {
                            parameter.$notify({
                                group: 'foo',
                                text: data.msg,
                                type: 'error'
                            });
                        }
                    }
                },
                    e => { _handleErrorResponse(e, commit) })
        } catch (ex) { _handleErrorResponse(ex, commit) }
    }
}

function _getImgeNameExntension(getImage) {
    let returnJson = {};
    returnJson['extension'] = getImage.split('.').slice(-1)[0]
    let getImageArray = getImage.split('.');
    getImageArray.pop();
    returnJson['docName'] = (getImageArray.length > 1) ? getImageArray.join(".") : getImageArray[0];
    return returnJson;
}

//------------------------------------------------------Functions------------------------------------------------------
function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) { }
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}
function _handleLogout(data, commit, options) {
    let user = {}
    const state = []
    window.sessionStorage.setItem('user_info', "")
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}



function _messageDisplayFunction(getParameter, getMessage, msgType) {
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}


function _executeApi(apiLink, credentials, getLoaderParams, getToken, commit, callback) {
    try {
        let response_array = [];
        if (credentials.localParams.module == 'ticket-reply') { credentials.globalParams = credentials.globalParams.form }
        else if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        getLoaderParams.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                getLoaderParams.pageLoader = false
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        callback(false, response_array)
                    }
                    else {
                        response_array.res_data = data.msg
                        callback(true, response_array)
                    }
                }
            },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}






// WEBPACK FOOTER //
// ./src/plugins/prism_admin/provider/candle-history/store-addons/actions.js